{
  "en": {
    "{0} · {1} C": "{0} · {1} C",
    "{0} «{1}»": "{0} “{1}”",
    "{0} с": "{0} s",
    "{0} сек": "{0} sec",
    "{0} секунд": "{0} seconds",
    "{0}: из чего": "{0}: source",
    "Без обрезки, как снято": "No cropping, as shot",
    "Без политики и запрещённых тем": "No politics or prohibited topics",
    "Бот уже прислал его в чат, в отдельную тему.": "The bot has already sent it to the chat, in a separate topic.",
    "Бот уже прислал их в чат, в отдельную тему.": "The bot has already sent them to the chat, in a separate topic.",
    "В кафе": "In a café",
    "В работу идёт до 10 секунд ролика. Из длинного выберите фрагмент под рамкой": "Up to 10 seconds of the clip are used. For a long clip, pick a fragment under the frame",
    "Варианты готовы": "Options ready",
    "Ваш товар": "Your product",
    "Ваше видео": "Your video",
    "Ваше описание": "Your description",
    "Вернём естественные цвета": "We will bring back natural colors",
    "Видео будет со звуком: модель сама сгенерирует фон, шумы и музыку по сюжету. Речь можно добавить после создания: «Добавить речь»": "The video will have sound: the model will generate the background, noises and music for the plot. You can add speech after creation: “Add speech”",
    "Видео ещё загружается": "The video is still loading",
    "Видео меняется по вашему описанию": "The video changes by your description",
    "Видео не прошло проверку": "The video did not pass the check",
    "видео не создано": "the video was not created",
    "Видео проверено": "Video checked",
    "Восстанавливаем детали": "Restoring the details",
    "Восстановление": "Restoration",
    "Все движения": "All motions",
    "Вы в кадре": "You are in the frame",
    "Выберите кадр": "Choose the frame",
    "Город ночью": "City at night",
    "Готовим файлы": "Preparing the files",
    "Двигаем камеру": "Moving the camera",
    "Движение снято": "Motion shot",
    "движений": "motions",
    "движения": "motion",
    "Держит за руку": "Holds my hand",
    "Детали восстановлены": "Details restored",
    "Для аватарки и ленты": "For avatars and the feed",
    "Для ленты": "For the feed",
    "Для обложки и экрана": "For covers and screens",
    "Для Reels, Shorts и сторис": "For Reels, Shorts and stories",
    "Для YouTube и экрана": "For YouTube and screens",
    "до 10 сек": "up to 10 sec",
    "Добавьте описание, от {0} знаков": "Add a description, at least {0} characters",
    "Добавьте свои фото в «Кто в кадре»": "Add your photos in “Who’s in the frame”",
    "Добавьте фото людям в кадре": "Add photos for the people in the frame",
    "за фото": "per photo",
    "Загрузите видео заново": "Upload the video again",
    "Загрузите старое фото": "Upload an old photo",
    "Загрузите фото заново": "Upload the photo again",
    "Загрузите фото товара": "Upload a product photo",
    "Загрузите чёрно-белое фото": "Upload a black-and-white photo",
    "Заменить видео": "Replace video",
    "Заменить фото": "Replace the photo",
    "Звук": "Sound",
    "Идёт рядом": "Walks beside me",
    "из кадра": "from the frame",
    "Из файла": "From file",
    "Из фото": "From photo",
    "Изменено": "Changed",
    "Изменить описание": "Edit the description",
    "Искать среди {0} {1}": "Search among {0} {1}",
    "Искать среди {0} {1} шаблона": "Search among {0} template {1}",
    "Кадры ожили": "The frames came to life",
    "Как снимок с телефона": "Like a phone shot",
    "Как у видео": "Like the video",
    "Камера прошла": "Camera move done",
    "Картинка только по вашему описанию": "An image from your description only",
    "Кафе": "Café",
    "Космос": "Space",
    "Лес": "Forest",
    "Лицо крупно, хороший свет": "Face up close, good light",
    "Люди в кадре": "People are in the frame",
    "Меняем по описанию": "Changing by the description",
    "Можно уйти с экрана: бот пришлёт готовые фото в чат.": "You can leave the screen: the bot will send the finished photos to the chat.",
    "Можно уйти с экрана: бот пришлёт ролик в чат.": "You can leave the screen: the bot will send the clip to the chat.",
    "На весь экран телефона": "Full phone screen",
    "на видео": "on the video",
    "На природе": "In nature",
    "на фото": "on the photo",
    "Нажмите, чтобы выбрать движение": "Tap to choose a motion",
    "Нажмите, чтобы выбрать стиль": "Tap to choose a style",
    "Нарисовано": "Drawn",
    "Не получилось сделать видео": "Could not make the video",
    "Не получилось сделать фото": "Could not make the photo",
    "Не прошло проверку": "Did not pass the check",
    "не участвует в этом видео": "is not in this video",
    "не участвует в этом фото": "is not in this photo",
    "Необязательно": "Optional",
    "Обнимает меня": "Hugs me",
    "Объём построен": "Depth built",
    "Оживляем кадры": "Bringing the frames to life",
    "Оживляем фото": "Bringing the photo to life",
    "Океан": "Ocean",
    "Описание длиннее {0} знаков": "The description is longer than {0} characters",
    "Описание не прошло проверку": "The description did not pass the check",
    "Описание проверено": "Description checked",
    "От модели": "By the model",
    "Пейзаж, портрет или любой снимок": "Landscape, portrait or any photo",
    "Переносим стиль на кадры": "Transferring the style to the frames",
    "Переносим стиль с картинки": "Transferring the style from the image",
    "Подходит для": "Suits",
    "Портрет в студии": "Studio portrait",
    "Портрет, селфи": "Portraits, selfies",
    "Применяем стиль": "Applying the style",
    "Проверяем видео": "Checking the video",
    "Проверяем картинку": "Checking the image",
    "Проверяем описание": "Checking the description",
    "Проверяем фото": "Checking the photo",
    "Раскрашено": "Colorized",
    "Раскрашиваем": "Colorizing",
    "Рисуем варианты": "Drawing the variants",
    "Рисуем по описанию": "Drawing from the description",
    "Ролик собран": "Clip assembled",
    "Ролик только по вашему описанию": "A clip from your description only",
    "Ролик, который изменим": "A clip we will change",
    "Свет поставлен": "Light set",
    "Селфи, портрет или любой снимок": "Selfie, portrait or any photo",
    "Скачать № {0}": "Download No. {0}",
    "Смеётся": "Laughs",
    "Смотрит в камеру": "Looks at the camera",
    "Снимаем движение": "Shooting the motion",
    "Снимаем по описанию": "Shooting from the description",
    "Снимем из главного фото. Нажмите на фото, чтобы выбрать кадр": "We shoot from the main photo. Tap a photo to choose the frame",
    "Снимок оживёт движением камеры": "The photo will come to life with a camera move",
    "Снято": "Shot",
    "Собираем ролик": "Assembling the clip",
    "Создаём {0} фото": "Creating {0} photos",
    "Создать {0} фото": "Create {0} photos",
    "Ставим вас в кадр": "Placing you in the frame",
    "Ставим людей в кадр": "Placing people in the frame",
    "Ставим свет": "Setting up the light",
    "Старый снимок или скан": "Old photo or scan",
    "стилей": "styles",
    "Стили": "Styles",
    "Стиль перенесён": "Style transferred",
    "Стиль применён": "Style applied",
    "Стиль шаблона": "Template style",
    "Стиль STEOS": "STEOS style",
    "стиля": "style",
    "Строим объём": "Building the depth",
    "Танцует": "Dances",
    "Товар крупно, на любом фоне": "Product up close, any background",
    "Только для этого видео": "Only for this video",
    "Только для этого фото": "Only for this photo",
    "Тут откроется тема чата, куда бот прислал ролик": "This will open the chat topic where the bot sent the clip",
    "Тут откроется тема чата, куда бот прислал фото": "This will open the chat topic where the bot sent the photo",
    "У моря": "By the sea",
    "Уберём царапины, шум и выцветание": "We will remove scratches, noise and fading",
    "Удалить из этого видео": "Remove from this video",
    "Удалить из этого фото": "Remove from this photo",
    "Улыбается": "Smiles",
    "Файлы готовы": "Files ready",
    "Фото готово": "Photo is ready",
    "Фото меняется только по вашему описанию": "The photo changes only by your description",
    "Фото не прошло проверку": "The photo did not pass the check",
    "фото не создано": "the photo was not created",
    "Фото оживает как есть, без стиля": "The photo comes to life as is, without a style",
    "Фото оживим, видео изменим": "We bring photos to life and change videos",
    "Фото ожило": "The photo came to life",
    "Фото проверено": "Photo checked",
    "Фото, которое оживёт": "A photo to bring to life",
    "Фото, ролик, текст": "Photo, clip, text",
    "Цена": "Price",
    "Чёрно-белый снимок или скан": "Black-and-white photo or scan",
    "Что поменять": "What to change",
    "Что снимать": "What to shoot",
    "Шаблон «{0}»": "Template “{0}”"
  },
  "hy": {
    "{0} · {1} C": "{0} · {1} C",
    "{0} «{1}»": "{0} «{1}»",
    "{0} с": "{0} վ",
    "{0} сек": "{0} վրկ",
    "{0} секунд": "{0} վայրկյան",
    "{0}: из чего": "{0}՝ ինչից",
    "Без обрезки, как снято": "Առանց կտրելու, ինչպես նկարված է",
    "Без политики и запрещённых тем": "Առանց քաղաքականության և արգելված թեմաների",
    "Бот уже прислал его в чат, в отдельную тему.": "Բոտն արդեն ուղարկել է այն չատ՝ առանձին թեմայում։",
    "Бот уже прислал их в чат, в отдельную тему.": "Բոտն արդեն ուղարկել է դրանք չատ՝ առանձին թեմայում։",
    "В кафе": "Սրճարանում",
    "В работу идёт до 10 секунд ролика. Из длинного выберите фрагмент под рамкой": "Աշխատանքի մեջ մտնում է տեսահոլովակի մինչև 10 վայրկյանը։ Երկարից ընտրեք հատված շրջանակի տակ",
    "Варианты готовы": "Տարբերակները պատրաստ են",
    "Ваш товар": "Ձեր ապրանքը",
    "Ваше видео": "Ձեր տեսանյութը",
    "Ваше описание": "Ձեր նկարագրությունը",
    "Вернём естественные цвета": "Կվերադարձնենք բնական գույները",
    "Видео будет со звуком: модель сама сгенерирует фон, шумы и музыку по сюжету. Речь можно добавить после создания: «Добавить речь»": "Տեսանյութը կլինի ձայնով՝ մոդելն ինքը կստեղծի ֆոնը, աղմուկները և երաժշտությունը ըստ սյուժեի։ Խոսք կարելի է ավելացնել ստեղծելուց հետո՝ «Ավելացնել խոսք»",
    "Видео ещё загружается": "Տեսանյութը դեռ բեռնվում է",
    "Видео меняется по вашему описанию": "Տեսանյութը փոխվում է ձեր նկարագրությամբ",
    "Видео не прошло проверку": "Տեսանյութը չանցավ ստուգումը",
    "видео не создано": "տեսանյութը չստեղծվեց",
    "Видео проверено": "Տեսանյութը ստուգված է",
    "Восстанавливаем детали": "Վերականգնում ենք մանրամասները",
    "Восстановление": "Վերականգնում",
    "Все движения": "Բոլոր շարժումները",
    "Вы в кадре": "Դուք կադրում եք",
    "Выберите кадр": "Ընտրեք կադրը",
    "Город ночью": "Գիշերային քաղաք",
    "Готовим файлы": "Պատրաստում ենք ֆայլերը",
    "Двигаем камеру": "Շարժում ենք տեսախցիկը",
    "Движение снято": "Շարժումը նկարված է",
    "движений": "շարժումների",
    "движения": "շարժման",
    "Держит за руку": "Բռնել է ձեռքս",
    "Детали восстановлены": "Մանրամասները վերականգնված են",
    "Для аватарки и ленты": "Ավատարի և լրահոսի համար",
    "Для ленты": "Լրահոսի համար",
    "Для обложки и экрана": "Շապիկի և էկրանի համար",
    "Для Reels, Shorts и сторис": "Reels-ի, Shorts-ի և սթորիների համար",
    "Для YouTube и экрана": "YouTube-ի և էկրանի համար",
    "до 10 сек": "մինչև 10 վրկ",
    "Добавьте описание, от {0} знаков": "Ավելացրեք նկարագրություն՝ առնվազն {0} նիշ",
    "Добавьте свои фото в «Кто в кадре»": "Ավելացրեք ձեր լուսանկարները «Ով է կադրում» բաժնում",
    "Добавьте фото людям в кадре": "Ավելացրեք լուսանկարներ կադրում գտնվող մարդկանց համար",
    "за фото": "մեկ լուսանկարի համար",
    "Загрузите видео заново": "Վերբեռնեք տեսանյութը նորից",
    "Загрузите старое фото": "Վերբեռնեք հին լուսանկար",
    "Загрузите фото заново": "Վերբեռնեք լուսանկարը նորից",
    "Загрузите фото товара": "Վերբեռնեք ապրանքի լուսանկարը",
    "Загрузите чёрно-белое фото": "Վերբեռնեք սև-սպիտակ լուսանկար",
    "Заменить видео": "Փոխարինել տեսանյութը",
    "Заменить фото": "Փոխել լուսանկարը",
    "Звук": "Ձայն",
    "Идёт рядом": "Քայլում է կողքիս",
    "из кадра": "կադրից",
    "Из файла": "Ֆայլից",
    "Из фото": "Լուսանկարից",
    "Изменено": "Փոխված է",
    "Изменить описание": "Փոխել նկարագրությունը",
    "Искать среди {0} {1}": "Որոնել {0} {1} մեջ",
    "Искать среди {0} {1} шаблона": "Որոնել ձևանմուշի {0} {1} մեջ",
    "Кадры ожили": "Կադրերը կենդանացան",
    "Как снимок с телефона": "Ինչպես հեռախոսով արված նկար",
    "Как у видео": "Ինչպես տեսանյութում",
    "Камера прошла": "Տեսախցիկն անցավ",
    "Картинка только по вашему описанию": "Պատկեր միայն ձեր նկարագրությամբ",
    "Кафе": "Սրճարան",
    "Космос": "Տիեզերք",
    "Лес": "Անտառ",
    "Лицо крупно, хороший свет": "Դեմքը մոտիկից, լավ լույս",
    "Люди в кадре": "Մարդիկ կադրում են",
    "Меняем по описанию": "Փոխում ենք ըստ նկարագրության",
    "Можно уйти с экрана: бот пришлёт готовые фото в чат.": "Կարող եք դուրս գալ էկրանից. բոտը պատրաստի լուսանկարները կուղարկի չատ։",
    "Можно уйти с экрана: бот пришлёт ролик в чат.": "Կարող եք դուրս գալ էկրանից. բոտը տեսահոլովակը կուղարկի չատ։",
    "На весь экран телефона": "Հեռախոսի ամբողջ էկրանով",
    "на видео": "տեսանյութի վրա",
    "На природе": "Բնության մեջ",
    "на фото": "լուսանկարի վրա",
    "Нажмите, чтобы выбрать движение": "Սեղմեք՝ շարժում ընտրելու համար",
    "Нажмите, чтобы выбрать стиль": "Սեղմեք՝ ոճ ընտրելու համար",
    "Нарисовано": "Նկարված է",
    "Не получилось сделать видео": "Չհաջողվեց ստեղծել տեսանյութը",
    "Не получилось сделать фото": "Չհաջողվեց ստեղծել լուսանկարը",
    "Не прошло проверку": "Չի անցել ստուգումը",
    "не участвует в этом видео": "չի մասնակցում այս տեսանյութին",
    "не участвует в этом фото": "չի մասնակցում այս լուսանկարին",
    "Необязательно": "Պարտադիր չէ",
    "Обнимает меня": "Գրկում է ինձ",
    "Объём построен": "Ծավալը կառուցված է",
    "Оживляем кадры": "Կենդանացնում ենք կադրերը",
    "Оживляем фото": "Կենդանացնում ենք լուսանկարը",
    "Океан": "Օվկիանոս",
    "Описание длиннее {0} знаков": "Նկարագրությունը {0} նիշից երկար է",
    "Описание не прошло проверку": "Նկարագրությունը չանցավ ստուգումը",
    "Описание проверено": "Նկարագրությունը ստուգված է",
    "От модели": "Մոդելից",
    "Пейзаж, портрет или любой снимок": "Բնանկար, դիմանկար կամ ցանկացած նկար",
    "Переносим стиль на кадры": "Տեղափոխում ենք ոճը կադրերին",
    "Переносим стиль с картинки": "Տեղափոխում ենք ոճը պատկերից",
    "Подходит для": "Հարմար է",
    "Портрет в студии": "Դիմանկար ստուդիայում",
    "Портрет, селфи": "Դիմանկար, սելֆի",
    "Применяем стиль": "Կիրառում ենք ոճը",
    "Проверяем видео": "Ստուգում ենք տեսանյութը",
    "Проверяем картинку": "Ստուգում ենք պատկերը",
    "Проверяем описание": "Ստուգում ենք նկարագրությունը",
    "Проверяем фото": "Ստուգում ենք լուսանկարը",
    "Раскрашено": "Գունավորված է",
    "Раскрашиваем": "Գունավորում ենք",
    "Рисуем варианты": "Նկարում ենք տարբերակները",
    "Рисуем по описанию": "Նկարում ենք ըստ նկարագրության",
    "Ролик собран": "Տեսահոլովակը հավաքված է",
    "Ролик только по вашему описанию": "Տեսահոլովակ միայն ձեր նկարագրությամբ",
    "Ролик, который изменим": "Տեսահոլովակ, որը կփոխենք",
    "Свет поставлен": "Լույսը տեղադրված է",
    "Селфи, портрет или любой снимок": "Սելֆի, դիմանկար կամ ցանկացած նկար",
    "Скачать № {0}": "Ներբեռնել № {0}",
    "Смеётся": "Ծիծաղում է",
    "Смотрит в камеру": "Նայում է տեսախցիկին",
    "Снимаем движение": "Նկարում ենք շարժումը",
    "Снимаем по описанию": "Նկարում ենք ըստ նկարագրության",
    "Снимем из главного фото. Нажмите на фото, чтобы выбрать кадр": "Կնկարենք գլխավոր լուսանկարից։ Սեղմեք լուսանկարին՝ կադրն ընտրելու համար",
    "Снимок оживёт движением камеры": "Նկարը կկենդանանա տեսախցիկի շարժումով",
    "Снято": "Նկարված է",
    "Собираем ролик": "Հավաքում ենք տեսահոլովակը",
    "Создаём {0} фото": "Ստեղծում ենք {0} լուսանկար",
    "Создать {0} фото": "Ստեղծել {0} լուսանկար",
    "Ставим вас в кадр": "Տեղադրում ենք ձեզ կադրում",
    "Ставим людей в кадр": "Տեղադրում ենք մարդկանց կադրում",
    "Ставим свет": "Տեղադրում ենք լույսը",
    "Старый снимок или скан": "Հին նկար կամ սկան",
    "стилей": "ոճերի",
    "Стили": "Ոճեր",
    "Стиль перенесён": "Ոճը տեղափոխված է",
    "Стиль применён": "Ոճը կիրառված է",
    "Стиль шаблона": "Ձևանմուշի ոճ",
    "Стиль STEOS": "STEOS ոճ",
    "стиля": "ոճի",
    "Строим объём": "Կառուցում ենք ծավալը",
    "Танцует": "Պարում է",
    "Товар крупно, на любом фоне": "Ապրանքը մոտիկից, ցանկացած ֆոնի վրա",
    "Только для этого видео": "Միայն այս տեսանյութի համար",
    "Только для этого фото": "Միայն այս լուսանկարի համար",
    "Тут откроется тема чата, куда бот прислал ролик": "Այստեղ կբացվի չատի թեման, որտեղ բոտն ուղարկել է տեսահոլովակը",
    "Тут откроется тема чата, куда бот прислал фото": "Այստեղ կբացվի չատի թեման, որտեղ բոտն ուղարկել է լուսանկարը",
    "У моря": "Ծովի մոտ",
    "Уберём царапины, шум и выцветание": "Կհեռացնենք քերծվածքները, աղմուկը և գունաթափումը",
    "Удалить из этого видео": "Հեռացնել այս տեսանյութից",
    "Удалить из этого фото": "Հեռացնել այս լուսանկարից",
    "Улыбается": "Ժպտում է",
    "Файлы готовы": "Ֆայլերը պատրաստ են",
    "Фото готово": "Լուսանկարը պատրաստ է",
    "Фото меняется только по вашему описанию": "Լուսանկարը փոխվում է միայն ձեր նկարագրությամբ",
    "Фото не прошло проверку": "Լուսանկարը չանցավ ստուգումը",
    "фото не создано": "լուսանկարը չի ստեղծվել",
    "Фото оживает как есть, без стиля": "Լուսանկարը կենդանանում է այնպես, ինչպես կա, առանց ոճի",
    "Фото оживим, видео изменим": "Լուսանկարը կկենդանացնենք, տեսանյութը կփոխենք",
    "Фото ожило": "Լուսանկարը կենդանացավ",
    "Фото проверено": "Լուսանկարը ստուգված է",
    "Фото, которое оживёт": "Լուսանկար, որը կկենդանանա",
    "Фото, ролик, текст": "Լուսանկար, տեսահոլովակ, տեքստ",
    "Цена": "Գին",
    "Чёрно-белый снимок или скан": "Սև-սպիտակ նկար կամ սկան",
    "Что поменять": "Ինչ փոխել",
    "Что снимать": "Ինչ նկարել",
    "Шаблон «{0}»": "«{0}» ձևանմուշ"
  },
  "es": {
    "{0} · {1} C": "{0} · {1} C",
    "{0} «{1}»": "{0} «{1}»",
    "{0} с": "{0} s",
    "{0} сек": "{0} s",
    "{0} секунд": "{0} segundos",
    "{0}: из чего": "{0}: a partir de qué",
    "Без обрезки, как снято": "Sin recortar, tal como se grabó",
    "Без политики и запрещённых тем": "Sin política ni temas prohibidos",
    "Бот уже прислал его в чат, в отдельную тему.": "El bot ya lo envió al chat, en un tema aparte.",
    "Бот уже прислал их в чат, в отдельную тему.": "El bot ya las envió al chat, en un tema aparte.",
    "В кафе": "En una cafetería",
    "В работу идёт до 10 секунд ролика. Из длинного выберите фрагмент под рамкой": "Se usan hasta 10 segundos del vídeo. Si es largo, elige un fragmento bajo el marco",
    "Варианты готовы": "Opciones listas",
    "Ваш товар": "Tu producto",
    "Ваше видео": "Tu vídeo",
    "Ваше описание": "Tu descripción",
    "Вернём естественные цвета": "Devolveremos los colores naturales",
    "Видео будет со звуком: модель сама сгенерирует фон, шумы и музыку по сюжету. Речь можно добавить после создания: «Добавить речь»": "El vídeo tendrá sonido: el modelo generará el fondo, los ruidos y la música según la trama. Puedes añadir voz después de crearlo: «Añadir voz»",
    "Видео ещё загружается": "El vídeo aún se está cargando",
    "Видео меняется по вашему описанию": "El vídeo cambia según tu descripción",
    "Видео не прошло проверку": "El vídeo no pasó la verificación",
    "видео не создано": "el vídeo no se creó",
    "Видео проверено": "Vídeo verificado",
    "Восстанавливаем детали": "Restaurando los detalles",
    "Восстановление": "Restauración",
    "Все движения": "Todos los movimientos",
    "Вы в кадре": "Estás en el encuadre",
    "Выберите кадр": "Elige el encuadre",
    "Город ночью": "Ciudad de noche",
    "Готовим файлы": "Preparando los archivos",
    "Двигаем камеру": "Moviendo la cámara",
    "Движение снято": "Movimiento grabado",
    "движений": "movimientos",
    "движения": "movimiento",
    "Держит за руку": "Me toma de la mano",
    "Детали восстановлены": "Detalles restaurados",
    "Для аватарки и ленты": "Para avatar y feed",
    "Для ленты": "Para el feed",
    "Для обложки и экрана": "Para portadas y pantallas",
    "Для Reels, Shorts и сторис": "Para Reels, Shorts e historias",
    "Для YouTube и экрана": "Para YouTube y pantalla",
    "до 10 сек": "hasta 10 s",
    "Добавьте описание, от {0} знаков": "Añade una descripción, desde {0} caracteres",
    "Добавьте свои фото в «Кто в кадре»": "Añade tus fotos en «Quién aparece en el fotograma»",
    "Добавьте фото людям в кадре": "Añade fotos de las personas del encuadre",
    "за фото": "por foto",
    "Загрузите видео заново": "Vuelve a subir el vídeo",
    "Загрузите старое фото": "Sube una foto antigua",
    "Загрузите фото заново": "Vuelve a subir la foto",
    "Загрузите фото товара": "Sube una foto del producto",
    "Загрузите чёрно-белое фото": "Sube una foto en blanco y negro",
    "Заменить видео": "Reemplazar vídeo",
    "Заменить фото": "Cambiar la foto",
    "Звук": "Sonido",
    "Идёт рядом": "Camina a mi lado",
    "из кадра": "del encuadre",
    "Из файла": "Desde archivo",
    "Из фото": "Desde foto",
    "Изменено": "Cambiado",
    "Изменить описание": "Editar la descripción",
    "Искать среди {0} {1}": "Buscar entre {0} {1}",
    "Искать среди {0} {1} шаблона": "Buscar entre {0} {1} de la plantilla",
    "Кадры ожили": "Los fotogramas cobraron vida",
    "Как снимок с телефона": "Como una foto de móvil",
    "Как у видео": "Como en el vídeo",
    "Камера прошла": "Movimiento de cámara hecho",
    "Картинка только по вашему описанию": "Una imagen solo según tu descripción",
    "Кафе": "Cafetería",
    "Космос": "Espacio",
    "Лес": "Bosque",
    "Лицо крупно, хороший свет": "Rostro de cerca, buena luz",
    "Люди в кадре": "Las personas están en el encuadre",
    "Меняем по описанию": "Cambiando según la descripción",
    "Можно уйти с экрана: бот пришлёт готовые фото в чат.": "Puedes salir de la pantalla: el bot enviará las fotos listas al chat.",
    "Можно уйти с экрана: бот пришлёт ролик в чат.": "Puedes salir de la pantalla: el bot enviará el vídeo al chat.",
    "На весь экран телефона": "Pantalla completa del móvil",
    "на видео": "en el vídeo",
    "На природе": "En la naturaleza",
    "на фото": "en la foto",
    "Нажмите, чтобы выбрать движение": "Toca para elegir un movimiento",
    "Нажмите, чтобы выбрать стиль": "Toca para elegir un estilo",
    "Нарисовано": "Dibujado",
    "Не получилось сделать видео": "No se pudo crear el vídeo",
    "Не получилось сделать фото": "No se pudo crear la foto",
    "Не прошло проверку": "No superó la revisión",
    "не участвует в этом видео": "no aparece en este vídeo",
    "не участвует в этом фото": "no aparece en esta foto",
    "Необязательно": "Opcional",
    "Обнимает меня": "Me abraza",
    "Объём построен": "Volumen creado",
    "Оживляем кадры": "Animando los fotogramas",
    "Оживляем фото": "Dando vida a la foto",
    "Океан": "Océano",
    "Описание длиннее {0} знаков": "La descripción supera los {0} caracteres",
    "Описание не прошло проверку": "La descripción no superó la revisión",
    "Описание проверено": "Descripción comprobada",
    "От модели": "Del modelo",
    "Пейзаж, портрет или любой снимок": "Paisaje, retrato o cualquier foto",
    "Переносим стиль на кадры": "Transfiriendo el estilo a los fotogramas",
    "Переносим стиль с картинки": "Transfiriendo el estilo de la imagen",
    "Подходит для": "Ideal para",
    "Портрет в студии": "Retrato de estudio",
    "Портрет, селфи": "Retratos, selfis",
    "Применяем стиль": "Aplicando el estilo",
    "Проверяем видео": "Verificando el vídeo",
    "Проверяем картинку": "Comprobando la imagen",
    "Проверяем описание": "Comprobando la descripción",
    "Проверяем фото": "Comprobando la foto",
    "Раскрашено": "Coloreado",
    "Раскрашиваем": "Coloreando",
    "Рисуем варианты": "Dibujando las variantes",
    "Рисуем по описанию": "Dibujando según la descripción",
    "Ролик собран": "Vídeo montado",
    "Ролик только по вашему описанию": "Un vídeo solo según tu descripción",
    "Ролик, который изменим": "Un vídeo que cambiaremos",
    "Свет поставлен": "Luz ajustada",
    "Селфи, портрет или любой снимок": "Selfi, retrato o cualquier foto",
    "Скачать № {0}": "Descargar n.º {0}",
    "Смеётся": "Se ríe",
    "Смотрит в камеру": "Mira a la cámara",
    "Снимаем движение": "Grabando el movimiento",
    "Снимаем по описанию": "Grabando según la descripción",
    "Снимем из главного фото. Нажмите на фото, чтобы выбрать кадр": "Grabamos a partir de la foto principal. Toca una foto para elegir el encuadre",
    "Снимок оживёт движением камеры": "La foto cobrará vida con un movimiento de cámara",
    "Снято": "Grabado",
    "Собираем ролик": "Montando el vídeo",
    "Создаём {0} фото": "Creando {0} fotos",
    "Создать {0} фото": "Crear {0} fotos",
    "Ставим вас в кадр": "Colocándote en el encuadre",
    "Ставим людей в кадр": "Colocando a las personas en el encuadre",
    "Ставим свет": "Ajustando la luz",
    "Старый снимок или скан": "Foto antigua o escaneo",
    "стилей": "estilos",
    "Стили": "Estilos",
    "Стиль перенесён": "Estilo transferido",
    "Стиль применён": "Estilo aplicado",
    "Стиль шаблона": "Estilo de la plantilla",
    "Стиль STEOS": "Estilo STEOS",
    "стиля": "estilo",
    "Строим объём": "Creando el volumen",
    "Танцует": "Baila",
    "Товар крупно, на любом фоне": "Producto de cerca, cualquier fondo",
    "Только для этого видео": "Solo para este vídeo",
    "Только для этого фото": "Solo para esta foto",
    "Тут откроется тема чата, куда бот прислал ролик": "Aquí se abrirá el tema del chat donde el bot envió el vídeo",
    "Тут откроется тема чата, куда бот прислал фото": "Aquí se abrirá el tema del chat donde el bot envió la foto",
    "У моря": "Junto al mar",
    "Уберём царапины, шум и выцветание": "Quitaremos arañazos, ruido y decoloración",
    "Удалить из этого видео": "Quitar de este vídeo",
    "Удалить из этого фото": "Quitar de esta foto",
    "Улыбается": "Sonríe",
    "Файлы готовы": "Archivos listos",
    "Фото готово": "Foto lista",
    "Фото меняется только по вашему описанию": "La foto cambia solo según tu descripción",
    "Фото не прошло проверку": "La foto no superó la revisión",
    "фото не создано": "la foto no se creó",
    "Фото оживает как есть, без стиля": "La foto cobra vida tal cual, sin estilo",
    "Фото оживим, видео изменим": "Animamos fotos y cambiamos vídeos",
    "Фото ожило": "La foto cobró vida",
    "Фото проверено": "Foto comprobada",
    "Фото, которое оживёт": "Una foto que cobrará vida",
    "Фото, ролик, текст": "Foto, vídeo, texto",
    "Цена": "Precio",
    "Чёрно-белый снимок или скан": "Foto en blanco y negro o escaneo",
    "Что поменять": "Qué cambiar",
    "Что снимать": "Qué grabar",
    "Шаблон «{0}»": "Plantilla «{0}»"
  },
  "de": {
    "{0} · {1} C": "{0} · {1} C",
    "{0} «{1}»": "{0} „{1}“",
    "{0} с": "{0} s",
    "{0} сек": "{0} Sek.",
    "{0} секунд": "{0} Sekunden",
    "{0}: из чего": "{0}: woraus",
    "Без обрезки, как снято": "Ohne Zuschnitt, wie aufgenommen",
    "Без политики и запрещённых тем": "Keine Politik und keine verbotenen Themen",
    "Бот уже прислал его в чат, в отдельную тему.": "Der Bot hat es bereits in einem eigenen Thema in den Chat geschickt.",
    "Бот уже прислал их в чат, в отдельную тему.": "Der Bot hat sie bereits in den Chat geschickt, in ein eigenes Thema.",
    "В кафе": "Im Café",
    "В работу идёт до 10 секунд ролика. Из длинного выберите фрагмент под рамкой": "Es werden bis zu 10 Sekunden des Clips verwendet. Wählen Sie bei einem langen Clip einen Ausschnitt unter dem Rahmen",
    "Варианты готовы": "Varianten fertig",
    "Ваш товар": "Ihr Produkt",
    "Ваше видео": "Ihr Video",
    "Ваше описание": "Ihre Beschreibung",
    "Вернём естественные цвета": "Wir bringen natürliche Farben zurück",
    "Видео будет со звуком: модель сама сгенерирует фон, шумы и музыку по сюжету. Речь можно добавить после создания: «Добавить речь»": "Das Video hat Ton: Das Modell erzeugt Hintergrund, Geräusche und Musik passend zur Handlung. Sprache können Sie nach dem Erstellen hinzufügen: „Sprache hinzufügen“",
    "Видео ещё загружается": "Das Video wird noch geladen",
    "Видео меняется по вашему описанию": "Das Video ändert sich nach Ihrer Beschreibung",
    "Видео не прошло проверку": "Das Video hat die Prüfung nicht bestanden",
    "видео не создано": "das Video wurde nicht erstellt",
    "Видео проверено": "Video geprüft",
    "Восстанавливаем детали": "Details werden wiederhergestellt",
    "Восстановление": "Restaurierung",
    "Все движения": "Alle Bewegungen",
    "Вы в кадре": "Sie sind im Bild",
    "Выберите кадр": "Wählen Sie den Ausschnitt",
    "Город ночью": "Stadt bei Nacht",
    "Готовим файлы": "Dateien werden vorbereitet",
    "Двигаем камеру": "Kamera wird bewegt",
    "Движение снято": "Bewegung gedreht",
    "движений": "Bewegungen",
    "движения": "Bewegung",
    "Держит за руку": "Hält meine Hand",
    "Детали восстановлены": "Details wiederhergestellt",
    "Для аватарки и ленты": "Für Avatar und Feed",
    "Для ленты": "Für den Feed",
    "Для обложки и экрана": "Für Cover und Bildschirm",
    "Для Reels, Shorts и сторис": "Für Reels, Shorts und Storys",
    "Для YouTube и экрана": "Für YouTube und Bildschirme",
    "до 10 сек": "bis 10 Sek.",
    "Добавьте описание, от {0} знаков": "Fügen Sie eine Beschreibung hinzu, ab {0} Zeichen",
    "Добавьте свои фото в «Кто в кадре»": "Fügen Sie Ihre Fotos unter „Wer ist im Bild“ hinzu",
    "Добавьте фото людям в кадре": "Fügen Sie Fotos der Personen im Bild hinzu",
    "за фото": "pro Foto",
    "Загрузите видео заново": "Laden Sie das Video erneut hoch",
    "Загрузите старое фото": "Laden Sie ein altes Foto hoch",
    "Загрузите фото заново": "Laden Sie das Foto erneut hoch",
    "Загрузите фото товара": "Laden Sie ein Produktfoto hoch",
    "Загрузите чёрно-белое фото": "Laden Sie ein Schwarzweißfoto hoch",
    "Заменить видео": "Video ersetzen",
    "Заменить фото": "Foto ersetzen",
    "Звук": "Ton",
    "Идёт рядом": "Geht neben mir",
    "из кадра": "aus dem Bild",
    "Из файла": "Aus Datei",
    "Из фото": "Aus Foto",
    "Изменено": "Geändert",
    "Изменить описание": "Beschreibung ändern",
    "Искать среди {0} {1}": "Unter {0} {1} suchen",
    "Искать среди {0} {1} шаблона": "Unter {0} {1} der Vorlage suchen",
    "Кадры ожили": "Die Bilder sind lebendig",
    "Как снимок с телефона": "Wie ein Handyfoto",
    "Как у видео": "Wie im Video",
    "Камера прошла": "Kamerafahrt fertig",
    "Картинка только по вашему описанию": "Ein Bild nur nach Ihrer Beschreibung",
    "Кафе": "Café",
    "Космос": "Weltall",
    "Лес": "Wald",
    "Лицо крупно, хороший свет": "Gesicht nah, gutes Licht",
    "Люди в кадре": "Personen sind im Bild",
    "Меняем по описанию": "Wird nach der Beschreibung geändert",
    "Можно уйти с экрана: бот пришлёт готовые фото в чат.": "Sie können den Bildschirm verlassen: Der Bot schickt die fertigen Fotos in den Chat.",
    "Можно уйти с экрана: бот пришлёт ролик в чат.": "Sie können den Bildschirm verlassen: Der Bot schickt den Clip in den Chat.",
    "На весь экран телефона": "Ganzer Handybildschirm",
    "на видео": "im Video",
    "На природе": "In der Natur",
    "на фото": "auf dem Foto",
    "Нажмите, чтобы выбрать движение": "Tippen Sie, um eine Bewegung zu wählen",
    "Нажмите, чтобы выбрать стиль": "Tippen Sie, um einen Stil zu wählen",
    "Нарисовано": "Gezeichnet",
    "Не получилось сделать видео": "Das Video konnte nicht erstellt werden",
    "Не получилось сделать фото": "Das Foto konnte nicht erstellt werden",
    "Не прошло проверку": "Prüfung nicht bestanden",
    "не участвует в этом видео": "ist nicht in diesem Video",
    "не участвует в этом фото": "ist nicht auf diesem Foto",
    "Необязательно": "Optional",
    "Обнимает меня": "Umarmt mich",
    "Объём построен": "Tiefe aufgebaut",
    "Оживляем кадры": "Bilder werden animiert",
    "Оживляем фото": "Das Foto wird lebendig",
    "Океан": "Ozean",
    "Описание длиннее {0} знаков": "Die Beschreibung ist länger als {0} Zeichen",
    "Описание не прошло проверку": "Die Beschreibung hat die Prüfung nicht bestanden",
    "Описание проверено": "Beschreibung geprüft",
    "От модели": "Vom Modell",
    "Пейзаж, портрет или любой снимок": "Landschaft, Porträt oder jedes Foto",
    "Переносим стиль на кадры": "Stil wird auf die Bilder übertragen",
    "Переносим стиль с картинки": "Stil wird vom Bild übertragen",
    "Подходит для": "Passt zu",
    "Портрет в студии": "Studioporträt",
    "Портрет, селфи": "Porträts, Selfies",
    "Применяем стиль": "Stil wird angewendet",
    "Проверяем видео": "Video wird geprüft",
    "Проверяем картинку": "Bild wird geprüft",
    "Проверяем описание": "Beschreibung wird geprüft",
    "Проверяем фото": "Foto wird geprüft",
    "Раскрашено": "Koloriert",
    "Раскрашиваем": "Wird koloriert",
    "Рисуем варианты": "Varianten werden gezeichnet",
    "Рисуем по описанию": "Wird nach der Beschreibung gezeichnet",
    "Ролик собран": "Clip zusammengesetzt",
    "Ролик только по вашему описанию": "Ein Clip nur nach Ihrer Beschreibung",
    "Ролик, который изменим": "Ein Clip, den wir ändern",
    "Свет поставлен": "Licht gesetzt",
    "Селфи, портрет или любой снимок": "Selfie, Porträt oder jedes Foto",
    "Скачать № {0}": "Nr. {0} herunterladen",
    "Смеётся": "Lacht",
    "Смотрит в камеру": "Schaut in die Kamera",
    "Снимаем движение": "Bewegung wird gedreht",
    "Снимаем по описанию": "Wird nach der Beschreibung gedreht",
    "Снимем из главного фото. Нажмите на фото, чтобы выбрать кадр": "Wir drehen aus dem Hauptfoto. Tippen Sie auf ein Foto, um den Ausschnitt zu wählen",
    "Снимок оживёт движением камеры": "Das Foto wird durch eine Kamerafahrt lebendig",
    "Снято": "Gedreht",
    "Собираем ролик": "Clip wird zusammengesetzt",
    "Создаём {0} фото": "{0} Fotos werden erstellt",
    "Создать {0} фото": "{0} Fotos erstellen",
    "Ставим вас в кадр": "Sie werden ins Bild gesetzt",
    "Ставим людей в кадр": "Personen werden ins Bild gesetzt",
    "Ставим свет": "Licht wird gesetzt",
    "Старый снимок или скан": "Altes Foto oder Scan",
    "стилей": "Stilen",
    "Стили": "Stile",
    "Стиль перенесён": "Stil übertragen",
    "Стиль применён": "Stil angewendet",
    "Стиль шаблона": "Vorlagenstil",
    "Стиль STEOS": "STEOS-Stil",
    "стиля": "Stil",
    "Строим объём": "Tiefe wird aufgebaut",
    "Танцует": "Tanzt",
    "Товар крупно, на любом фоне": "Produkt nah, beliebiger Hintergrund",
    "Только для этого видео": "Nur für dieses Video",
    "Только для этого фото": "Nur für dieses Foto",
    "Тут откроется тема чата, куда бот прислал ролик": "Hier öffnet sich das Chat-Thema, in das der Bot den Clip geschickt hat",
    "Тут откроется тема чата, куда бот прислал фото": "Hier öffnet sich das Chat-Thema, in das der Bot das Foto geschickt hat",
    "У моря": "Am Meer",
    "Уберём царапины, шум и выцветание": "Wir entfernen Kratzer, Rauschen und Verblassen",
    "Удалить из этого видео": "Aus diesem Video entfernen",
    "Удалить из этого фото": "Aus diesem Foto entfernen",
    "Улыбается": "Lächelt",
    "Файлы готовы": "Dateien fertig",
    "Фото готово": "Foto ist fertig",
    "Фото меняется только по вашему описанию": "Das Foto ändert sich nur nach Ihrer Beschreibung",
    "Фото не прошло проверку": "Das Foto hat die Prüfung nicht bestanden",
    "фото не создано": "das Foto wurde nicht erstellt",
    "Фото оживает как есть, без стиля": "Das Foto wird so lebendig, wie es ist, ohne Stil",
    "Фото оживим, видео изменим": "Fotos beleben wir, Videos verändern wir",
    "Фото ожило": "Das Foto ist lebendig",
    "Фото проверено": "Foto geprüft",
    "Фото, которое оживёт": "Ein Foto, das lebendig wird",
    "Фото, ролик, текст": "Foto, Clip, Text",
    "Цена": "Preis",
    "Чёрно-белый снимок или скан": "Schwarzweißfoto oder Scan",
    "Что поменять": "Was ändern",
    "Что снимать": "Was aufnehmen",
    "Шаблон «{0}»": "Vorlage „{0}“"
  },
  "fr": {
    "{0} · {1} C": "{0} · {1} C",
    "{0} «{1}»": "{0} « {1} »",
    "{0} с": "{0} s",
    "{0} сек": "{0} s",
    "{0} секунд": "{0} secondes",
    "{0}: из чего": "{0} : à partir de quoi",
    "Без обрезки, как снято": "Sans recadrage, tel quel",
    "Без политики и запрещённых тем": "Pas de politique ni de sujets interdits",
    "Бот уже прислал его в чат, в отдельную тему.": "Le bot l’a déjà envoyé dans le chat, dans un sujet à part.",
    "Бот уже прислал их в чат, в отдельную тему.": "Le bot les a déjà envoyées dans le chat, dans un sujet à part.",
    "В кафе": "Au café",
    "В работу идёт до 10 секунд ролика. Из длинного выберите фрагмент под рамкой": "Jusqu’à 10 secondes de la vidéo sont utilisées. Pour une vidéo longue, choisissez un extrait sous le cadre",
    "Варианты готовы": "Variantes prêtes",
    "Ваш товар": "Votre produit",
    "Ваше видео": "Votre vidéo",
    "Ваше описание": "Votre description",
    "Вернём естественные цвета": "Nous rendrons les couleurs naturelles",
    "Видео будет со звуком: модель сама сгенерирует фон, шумы и музыку по сюжету. Речь можно добавить после создания: «Добавить речь»": "La vidéo aura du son : le modèle générera le fond, les bruits et la musique selon l’histoire. Vous pourrez ajouter de la parole après la création : « Ajouter de la parole »",
    "Видео ещё загружается": "La vidéo est encore en cours de chargement",
    "Видео меняется по вашему описанию": "La vidéo change selon votre description",
    "Видео не прошло проверку": "La vidéo n’a pas passé la vérification",
    "видео не создано": "la vidéo n’a pas été créée",
    "Видео проверено": "Vidéo vérifiée",
    "Восстанавливаем детали": "Restauration des détails",
    "Восстановление": "Restauration",
    "Все движения": "Tous les mouvements",
    "Вы в кадре": "Vous êtes dans le cadre",
    "Выберите кадр": "Choisissez le cadrage",
    "Город ночью": "Ville la nuit",
    "Готовим файлы": "Préparation des fichiers",
    "Двигаем камеру": "Déplacement de la caméra",
    "Движение снято": "Mouvement tourné",
    "движений": "mouvements",
    "движения": "mouvement",
    "Держит за руку": "Me tient la main",
    "Детали восстановлены": "Détails restaurés",
    "Для аватарки и ленты": "Pour l’avatar et le fil",
    "Для ленты": "Pour le fil",
    "Для обложки и экрана": "Pour la couverture et l’écran",
    "Для Reels, Shorts и сторис": "Pour Reels, Shorts et stories",
    "Для YouTube и экрана": "Pour YouTube et l’écran",
    "до 10 сек": "jusqu’à 10 s",
    "Добавьте описание, от {0} знаков": "Ajoutez une description, au moins {0} caractères",
    "Добавьте свои фото в «Кто в кадре»": "Ajoutez vos photos dans « Personne dans le cadre »",
    "Добавьте фото людям в кадре": "Ajoutez des photos des personnes dans le cadre",
    "за фото": "par photo",
    "Загрузите видео заново": "Téléchargez la vidéo à nouveau",
    "Загрузите старое фото": "Téléchargez une vieille photo",
    "Загрузите фото заново": "Téléchargez la photo à nouveau",
    "Загрузите фото товара": "Ajoutez une photo du produit",
    "Загрузите чёрно-белое фото": "Téléchargez une photo noir et blanc",
    "Заменить видео": "Remplacer la vidéo",
    "Заменить фото": "Remplacer la photo",
    "Звук": "Son",
    "Идёт рядом": "Marche à côté de moi",
    "из кадра": "du cadre",
    "Из файла": "Depuis un fichier",
    "Из фото": "Depuis une photo",
    "Изменено": "Modifié",
    "Изменить описание": "Modifier la description",
    "Искать среди {0} {1}": "Rechercher parmi {0} {1}",
    "Искать среди {0} {1} шаблона": "Rechercher parmi {0} {1} du modèle",
    "Кадры ожили": "Les images se sont animées",
    "Как снимок с телефона": "Comme une photo au téléphone",
    "Как у видео": "Comme la vidéo",
    "Камера прошла": "Mouvement de caméra terminé",
    "Картинка только по вашему описанию": "Une image uniquement selon votre description",
    "Кафе": "Café",
    "Космос": "Espace",
    "Лес": "Forêt",
    "Лицо крупно, хороший свет": "Visage en gros plan, bonne lumière",
    "Люди в кадре": "Les personnes sont dans le cadre",
    "Меняем по описанию": "Modification d’après la description",
    "Можно уйти с экрана: бот пришлёт готовые фото в чат.": "Vous pouvez quitter l’écran : le bot enverra les photos prêtes dans le chat.",
    "Можно уйти с экрана: бот пришлёт ролик в чат.": "Vous pouvez quitter l’écran : le bot enverra la vidéo dans le chat.",
    "На весь экран телефона": "Plein écran du téléphone",
    "на видео": "sur la vidéo",
    "На природе": "Dans la nature",
    "на фото": "sur la photo",
    "Нажмите, чтобы выбрать движение": "Touchez pour choisir un mouvement",
    "Нажмите, чтобы выбрать стиль": "Touchez pour choisir un style",
    "Нарисовано": "Dessiné",
    "Не получилось сделать видео": "Impossible de créer la vidéo",
    "Не получилось сделать фото": "Impossible de créer la photo",
    "Не прошло проверку": "N’a pas passé la vérification",
    "не участвует в этом видео": "n’apparaît pas dans cette vidéo",
    "не участвует в этом фото": "n’apparaît pas sur cette photo",
    "Необязательно": "Facultatif",
    "Обнимает меня": "Me serre dans ses bras",
    "Объём построен": "Relief créé",
    "Оживляем кадры": "Animation des images",
    "Оживляем фото": "Animation de la photo",
    "Океан": "Océan",
    "Описание длиннее {0} знаков": "La description dépasse {0} caractères",
    "Описание не прошло проверку": "La description n’a pas passé la vérification",
    "Описание проверено": "Description vérifiée",
    "От модели": "Par le modèle",
    "Пейзаж, портрет или любой снимок": "Paysage, portrait ou n’importe quelle photo",
    "Переносим стиль на кадры": "Transfert du style sur les images",
    "Переносим стиль с картинки": "Transfert du style depuis l’image",
    "Подходит для": "Convient pour",
    "Портрет в студии": "Portrait en studio",
    "Портрет, селфи": "Portraits, selfies",
    "Применяем стиль": "Application du style",
    "Проверяем видео": "Vérification de la vidéo",
    "Проверяем картинку": "Vérification de l’image",
    "Проверяем описание": "Vérification de la description",
    "Проверяем фото": "Vérification de la photo",
    "Раскрашено": "Colorisé",
    "Раскрашиваем": "Colorisation",
    "Рисуем варианты": "Dessin des variantes",
    "Рисуем по описанию": "Dessin d’après la description",
    "Ролик собран": "Vidéo montée",
    "Ролик только по вашему описанию": "Une vidéo uniquement selon votre description",
    "Ролик, который изменим": "Une vidéo que nous modifierons",
    "Свет поставлен": "Lumière en place",
    "Селфи, портрет или любой снимок": "Selfie, portrait ou n’importe quelle photo",
    "Скачать № {0}": "Télécharger n° {0}",
    "Смеётся": "Rit",
    "Смотрит в камеру": "Regarde l’objectif",
    "Снимаем движение": "Tournage du mouvement",
    "Снимаем по описанию": "Tournage d’après la description",
    "Снимем из главного фото. Нажмите на фото, чтобы выбрать кадр": "Nous filmons à partir de la photo principale. Touchez une photo pour choisir le cadrage",
    "Снимок оживёт движением камеры": "La photo s’animera grâce à un mouvement de caméra",
    "Снято": "Tourné",
    "Собираем ролик": "Montage de la vidéo",
    "Создаём {0} фото": "Création de {0} photos",
    "Создать {0} фото": "Créer {0} photos",
    "Ставим вас в кадр": "Nous vous plaçons dans le cadre",
    "Ставим людей в кадр": "Nous plaçons les personnes dans le cadre",
    "Ставим свет": "Mise en place de la lumière",
    "Старый снимок или скан": "Vieille photo ou scan",
    "стилей": "styles",
    "Стили": "Styles",
    "Стиль перенесён": "Style transféré",
    "Стиль применён": "Style appliqué",
    "Стиль шаблона": "Style du modèle",
    "Стиль STEOS": "Style STEOS",
    "стиля": "style",
    "Строим объём": "Création du relief",
    "Танцует": "Danse",
    "Товар крупно, на любом фоне": "Produit en gros plan, n’importe quel fond",
    "Только для этого видео": "Uniquement pour cette vidéo",
    "Только для этого фото": "Uniquement pour cette photo",
    "Тут откроется тема чата, куда бот прислал ролик": "Ici s’ouvrira le sujet du chat où le bot a envoyé la vidéo",
    "Тут откроется тема чата, куда бот прислал фото": "Ici s’ouvrira le sujet du chat où le bot a envoyé la photo",
    "У моря": "Au bord de la mer",
    "Уберём царапины, шум и выцветание": "Nous retirerons les rayures, le bruit et la décoloration",
    "Удалить из этого видео": "Retirer de cette vidéo",
    "Удалить из этого фото": "Retirer de cette photo",
    "Улыбается": "Sourit",
    "Файлы готовы": "Fichiers prêts",
    "Фото готово": "Photo prête",
    "Фото меняется только по вашему описанию": "La photo change uniquement selon votre description",
    "Фото не прошло проверку": "La photo n’a pas passé la vérification",
    "фото не создано": "la photo n’a pas été créée",
    "Фото оживает как есть, без стиля": "La photo s’anime telle quelle, sans style",
    "Фото оживим, видео изменим": "Nous animons les photos et modifions les vidéos",
    "Фото ожило": "La photo est animée",
    "Фото проверено": "Photo vérifiée",
    "Фото, которое оживёт": "Une photo qui prendra vie",
    "Фото, ролик, текст": "Photo, vidéo, texte",
    "Цена": "Prix",
    "Чёрно-белый снимок или скан": "Photo noir et blanc ou scan",
    "Что поменять": "Quoi changer",
    "Что снимать": "Que filmer",
    "Шаблон «{0}»": "Modèle « {0} »"
  },
  "pt": {
    "{0} · {1} C": "{0} · {1} C",
    "{0} «{1}»": "{0} «{1}»",
    "{0} с": "{0} s",
    "{0} сек": "{0} s",
    "{0} секунд": "{0} segundos",
    "{0}: из чего": "{0}: a partir de quê",
    "Без обрезки, как снято": "Sem recorte, como foi feito",
    "Без политики и запрещённых тем": "Sem política nem temas proibidos",
    "Бот уже прислал его в чат, в отдельную тему.": "O bot já o enviou para o chat, num tópico separado.",
    "Бот уже прислал их в чат, в отдельную тему.": "O bot já as enviou para o chat, num tópico separado.",
    "В кафе": "Num café",
    "В работу идёт до 10 секунд ролика. Из длинного выберите фрагмент под рамкой": "São usados até 10 segundos do vídeo. Se for longo, escolha um trecho abaixo do quadro",
    "Варианты готовы": "Opções prontas",
    "Ваш товар": "Seu produto",
    "Ваше видео": "Seu vídeo",
    "Ваше описание": "Sua descrição",
    "Вернём естественные цвета": "Vamos devolver as cores naturais",
    "Видео будет со звуком: модель сама сгенерирует фон, шумы и музыку по сюжету. Речь можно добавить после создания: «Добавить речь»": "O vídeo terá som: o modelo vai gerar o fundo, os ruídos e a música conforme a história. Você pode adicionar fala depois de criar: «Adicionar fala»",
    "Видео ещё загружается": "O vídeo ainda está carregando",
    "Видео меняется по вашему описанию": "O vídeo muda pela sua descrição",
    "Видео не прошло проверку": "O vídeo não passou na verificação",
    "видео не создано": "o vídeo não foi criado",
    "Видео проверено": "Vídeo verificado",
    "Восстанавливаем детали": "Restaurando os detalhes",
    "Восстановление": "Restauração",
    "Все движения": "Todos os movimentos",
    "Вы в кадре": "Você está no quadro",
    "Выберите кадр": "Escolha o enquadramento",
    "Город ночью": "Cidade à noite",
    "Готовим файлы": "Preparando os arquivos",
    "Двигаем камеру": "Movendo a câmera",
    "Движение снято": "Movimento gravado",
    "движений": "movimentos",
    "движения": "movimento",
    "Держит за руку": "Segura minha mão",
    "Детали восстановлены": "Detalhes restaurados",
    "Для аватарки и ленты": "Para avatar e feed",
    "Для ленты": "Para o feed",
    "Для обложки и экрана": "Para capa e tela",
    "Для Reels, Shorts и сторис": "Para Reels, Shorts e stories",
    "Для YouTube и экрана": "Para YouTube e ecrã",
    "до 10 сек": "até 10 s",
    "Добавьте описание, от {0} знаков": "Adicione uma descrição, a partir de {0} caracteres",
    "Добавьте свои фото в «Кто в кадре»": "Adicione suas fotos em «Quem está no quadro»",
    "Добавьте фото людям в кадре": "Adicione fotos das pessoas no quadro",
    "за фото": "por foto",
    "Загрузите видео заново": "Envie o vídeo novamente",
    "Загрузите старое фото": "Envie uma foto antiga",
    "Загрузите фото заново": "Envie a foto novamente",
    "Загрузите фото товара": "Envie uma foto do produto",
    "Загрузите чёрно-белое фото": "Envie uma foto em preto e branco",
    "Заменить видео": "Substituir vídeo",
    "Заменить фото": "Trocar a foto",
    "Звук": "Som",
    "Идёт рядом": "Caminha ao meu lado",
    "из кадра": "do quadro",
    "Из файла": "A partir de arquivo",
    "Из фото": "A partir de foto",
    "Изменено": "Alterado",
    "Изменить описание": "Editar a descrição",
    "Искать среди {0} {1}": "Pesquisar entre {0} {1}",
    "Искать среди {0} {1} шаблона": "Pesquisar entre {0} {1} do modelo",
    "Кадры ожили": "Os quadros ganharam vida",
    "Как снимок с телефона": "Como uma foto de celular",
    "Как у видео": "Como no vídeo",
    "Камера прошла": "Movimento de câmera feito",
    "Картинка только по вашему описанию": "Uma imagem apenas pela sua descrição",
    "Кафе": "Café",
    "Космос": "Espaço",
    "Лес": "Floresta",
    "Лицо крупно, хороший свет": "Rosto de perto, boa luz",
    "Люди в кадре": "As pessoas estão no quadro",
    "Меняем по описанию": "Alterando pela descrição",
    "Можно уйти с экрана: бот пришлёт готовые фото в чат.": "Pode sair da tela: o bot enviará as fotos prontas para o chat.",
    "Можно уйти с экрана: бот пришлёт ролик в чат.": "Pode sair da tela: o bot enviará o vídeo para o chat.",
    "На весь экран телефона": "Tela cheia do celular",
    "на видео": "no vídeo",
    "На природе": "Na natureza",
    "на фото": "na foto",
    "Нажмите, чтобы выбрать движение": "Toque para escolher um movimento",
    "Нажмите, чтобы выбрать стиль": "Toque para escolher um estilo",
    "Нарисовано": "Desenhado",
    "Не получилось сделать видео": "Não foi possível criar o vídeo",
    "Не получилось сделать фото": "Não foi possível criar a foto",
    "Не прошло проверку": "Não passou na verificação",
    "не участвует в этом видео": "não aparece neste vídeo",
    "не участвует в этом фото": "não aparece nesta foto",
    "Необязательно": "Opcional",
    "Обнимает меня": "Me abraça",
    "Объём построен": "Volume criado",
    "Оживляем кадры": "Animando os quadros",
    "Оживляем фото": "A dar vida à foto",
    "Океан": "Oceano",
    "Описание длиннее {0} знаков": "A descrição tem mais de {0} caracteres",
    "Описание не прошло проверку": "A descrição não passou na verificação",
    "Описание проверено": "Descrição verificada",
    "От модели": "Do modelo",
    "Пейзаж, портрет или любой снимок": "Paisagem, retrato ou qualquer foto",
    "Переносим стиль на кадры": "Transferindo o estilo para os quadros",
    "Переносим стиль с картинки": "Transferindo o estilo da imagem",
    "Подходит для": "Combina com",
    "Портрет в студии": "Retrato em estúdio",
    "Портрет, селфи": "Retratos, selfies",
    "Применяем стиль": "Aplicando o estilo",
    "Проверяем видео": "A verificar o vídeo",
    "Проверяем картинку": "Verificando a imagem",
    "Проверяем описание": "Verificando a descrição",
    "Проверяем фото": "Verificando a foto",
    "Раскрашено": "Colorido",
    "Раскрашиваем": "Colorindo",
    "Рисуем варианты": "Desenhando as variantes",
    "Рисуем по описанию": "Desenhando pela descrição",
    "Ролик собран": "Vídeo montado",
    "Ролик только по вашему описанию": "Um vídeo apenas pela sua descrição",
    "Ролик, который изменим": "Um vídeo que vamos alterar",
    "Свет поставлен": "Luz ajustada",
    "Селфи, портрет или любой снимок": "Selfie, retrato ou qualquer foto",
    "Скачать № {0}": "Baixar n.º {0}",
    "Смеётся": "Ri-se",
    "Смотрит в камеру": "Olha para a câmera",
    "Снимаем движение": "Gravando o movimento",
    "Снимаем по описанию": "Gravando pela descrição",
    "Снимем из главного фото. Нажмите на фото, чтобы выбрать кадр": "Gravamos a partir da foto principal. Toque numa foto para escolher o enquadramento",
    "Снимок оживёт движением камеры": "A foto vai ganhar vida com um movimento de câmera",
    "Снято": "Gravado",
    "Собираем ролик": "Montando o vídeo",
    "Создаём {0} фото": "Criando {0} fotos",
    "Создать {0} фото": "Criar {0} fotos",
    "Ставим вас в кадр": "Colocando você no quadro",
    "Ставим людей в кадр": "Colocando as pessoas no quadro",
    "Ставим свет": "Ajustando a luz",
    "Старый снимок или скан": "Foto antiga ou digitalização",
    "стилей": "estilos",
    "Стили": "Estilos",
    "Стиль перенесён": "Estilo transferido",
    "Стиль применён": "Estilo aplicado",
    "Стиль шаблона": "Estilo do modelo",
    "Стиль STEOS": "Estilo STEOS",
    "стиля": "estilo",
    "Строим объём": "Criando o volume",
    "Танцует": "Dança",
    "Товар крупно, на любом фоне": "Produto de perto, qualquer fundo",
    "Только для этого видео": "Só para este vídeo",
    "Только для этого фото": "Só para esta foto",
    "Тут откроется тема чата, куда бот прислал ролик": "Aqui vai abrir o tópico do chat onde o bot enviou o vídeo",
    "Тут откроется тема чата, куда бот прислал фото": "Aqui vai abrir o tópico do chat onde o bot enviou a foto",
    "У моря": "À beira-mar",
    "Уберём царапины, шум и выцветание": "Vamos remover arranhões, ruído e desbotamento",
    "Удалить из этого видео": "Remover deste vídeo",
    "Удалить из этого фото": "Remover desta foto",
    "Улыбается": "Sorri",
    "Файлы готовы": "Arquivos prontos",
    "Фото готово": "Foto pronta",
    "Фото меняется только по вашему описанию": "A foto muda apenas pela sua descrição",
    "Фото не прошло проверку": "A foto não passou na verificação",
    "фото не создано": "a foto não foi criada",
    "Фото оживает как есть, без стиля": "A foto ganha vida como está, sem estilo",
    "Фото оживим, видео изменим": "Damos vida a fotos e alteramos vídeos",
    "Фото ожило": "A foto ganhou vida",
    "Фото проверено": "Foto verificada",
    "Фото, которое оживёт": "Uma foto que vai ganhar vida",
    "Фото, ролик, текст": "Foto, vídeo, texto",
    "Цена": "Preço",
    "Чёрно-белый снимок или скан": "Foto em preto e branco ou digitalização",
    "Что поменять": "O que trocar",
    "Что снимать": "O que gravar",
    "Шаблон «{0}»": "Modelo «{0}»"
  },
  "tr": {
    "{0} · {1} C": "{0} · {1} C",
    "{0} «{1}»": "{0} «{1}»",
    "{0} с": "{0} sn",
    "{0} сек": "{0} sn",
    "{0} секунд": "{0} saniye",
    "{0}: из чего": "{0}: neyden",
    "Без обрезки, как снято": "Kırpmadan, çekildiği gibi",
    "Без политики и запрещённых тем": "Siyaset ve yasaklı konular yok",
    "Бот уже прислал его в чат, в отдельную тему.": "Bot onu sohbete, ayrı bir konuya zaten gönderdi.",
    "Бот уже прислал их в чат, в отдельную тему.": "Bot bunları zaten sohbete, ayrı bir konuya gönderdi.",
    "В кафе": "Kafede",
    "В работу идёт до 10 секунд ролика. Из длинного выберите фрагмент под рамкой": "Videonun en fazla 10 saniyesi kullanılır. Uzun bir videoda çerçevenin altından bir parça seçin",
    "Варианты готовы": "Seçenekler hazır",
    "Ваш товар": "Ürününüz",
    "Ваше видео": "Videonuz",
    "Ваше описание": "Açıklamanız",
    "Вернём естественные цвета": "Doğal renkleri geri getiririz",
    "Видео будет со звуком: модель сама сгенерирует фон, шумы и музыку по сюжету. Речь можно добавить после создания: «Добавить речь»": "Video sesli olacak: model arka planı, sesleri ve müziği senaryoya göre kendisi üretecek. Konuşmayı oluşturduktan sonra ekleyebilirsiniz: «Konuşma ekle»",
    "Видео ещё загружается": "Video hâlâ yükleniyor",
    "Видео меняется по вашему описанию": "Video açıklamanıza göre değişir",
    "Видео не прошло проверку": "Video kontrolden geçmedi",
    "видео не создано": "video oluşturulmadı",
    "Видео проверено": "Video kontrol edildi",
    "Восстанавливаем детали": "Ayrıntılar onarılıyor",
    "Восстановление": "Restorasyon",
    "Все движения": "Tüm hareketler",
    "Вы в кадре": "Karedesiniz",
    "Выберите кадр": "Kadrajı seçin",
    "Город ночью": "Gece şehir",
    "Готовим файлы": "Dosyalar hazırlanıyor",
    "Двигаем камеру": "Kamera hareket ettiriliyor",
    "Движение снято": "Hareket çekildi",
    "движений": "hareket",
    "движения": "hareket",
    "Держит за руку": "Elimi tutuyor",
    "Детали восстановлены": "Ayrıntılar onarıldı",
    "Для аватарки и ленты": "Avatar ve akış için",
    "Для ленты": "Akış için",
    "Для обложки и экрана": "Kapak ve ekran için",
    "Для Reels, Shorts и сторис": "Reels, Shorts ve hikâyeler için",
    "Для YouTube и экрана": "YouTube ve ekran için",
    "до 10 сек": "10 sn’ye kadar",
    "Добавьте описание, от {0} знаков": "En az {0} karakterlik bir açıklama ekleyin",
    "Добавьте свои фото в «Кто в кадре»": "«Karede kim var» bölümüne fotoğraflarınızı ekleyin",
    "Добавьте фото людям в кадре": "Karedeki kişilere fotoğraf ekleyin",
    "за фото": "fotoğraf başına",
    "Загрузите видео заново": "Videoyu yeniden yükleyin",
    "Загрузите старое фото": "Eski bir fotoğraf yükleyin",
    "Загрузите фото заново": "Fotoğrafı yeniden yükleyin",
    "Загрузите фото товара": "Ürün fotoğrafı yükleyin",
    "Загрузите чёрно-белое фото": "Siyah-beyaz bir fotoğraf yükleyin",
    "Заменить видео": "Videoyu değiştir",
    "Заменить фото": "Fotoğrafı değiştir",
    "Звук": "Ses",
    "Идёт рядом": "Yanımda yürüyor",
    "из кадра": "kareden",
    "Из файла": "Dosyadan",
    "Из фото": "Fotoğraftan",
    "Изменено": "Değiştirildi",
    "Изменить описание": "Açıklamayı düzenle",
    "Искать среди {0} {1}": "{0} {1} arasında ara",
    "Искать среди {0} {1} шаблона": "Şablonun {0} {1} arasında ara",
    "Кадры ожили": "Kareler canlandı",
    "Как снимок с телефона": "Telefon çekimi gibi",
    "Как у видео": "Videodaki gibi",
    "Камера прошла": "Kamera hareketi tamam",
    "Картинка только по вашему описанию": "Yalnızca açıklamanıza göre bir görsel",
    "Кафе": "Kafe",
    "Космос": "Uzay",
    "Лес": "Orman",
    "Лицо крупно, хороший свет": "Yüz yakın plan, iyi ışık",
    "Люди в кадре": "Kişiler karede",
    "Меняем по описанию": "Açıklamaya göre değiştiriliyor",
    "Можно уйти с экрана: бот пришлёт готовые фото в чат.": "Ekrandan çıkabilirsiniz: bot hazır fotoğrafları sohbete gönderecek.",
    "Можно уйти с экрана: бот пришлёт ролик в чат.": "Ekrandan çıkabilirsiniz: bot videoyu sohbete gönderecek.",
    "На весь экран телефона": "Tam telefon ekranı",
    "на видео": "videoda",
    "На природе": "Doğada",
    "на фото": "fotoğrafta",
    "Нажмите, чтобы выбрать движение": "Hareket seçmek için dokunun",
    "Нажмите, чтобы выбрать стиль": "Stil seçmek için dokunun",
    "Нарисовано": "Çizildi",
    "Не получилось сделать видео": "Video oluşturulamadı",
    "Не получилось сделать фото": "Fotoğraf oluşturulamadı",
    "Не прошло проверку": "Kontrolden geçmedi",
    "не участвует в этом видео": "bu videoda yok",
    "не участвует в этом фото": "bu fotoğrafta yok",
    "Необязательно": "İsteğe bağlı",
    "Обнимает меня": "Bana sarılıyor",
    "Объём построен": "Hacim oluşturuldu",
    "Оживляем кадры": "Kareler canlandırılıyor",
    "Оживляем фото": "Fotoğraf canlandırılıyor",
    "Океан": "Okyanus",
    "Описание длиннее {0} знаков": "Açıklama {0} karakterden uzun",
    "Описание не прошло проверку": "Açıklama kontrolden geçmedi",
    "Описание проверено": "Açıklama kontrol edildi",
    "От модели": "Modelden",
    "Пейзаж, портрет или любой снимок": "Manzara, portre veya herhangi bir fotoğraf",
    "Переносим стиль на кадры": "Stil karelere aktarılıyor",
    "Переносим стиль с картинки": "Stil görselden aktarılıyor",
    "Подходит для": "Uygun olduğu",
    "Портрет в студии": "Stüdyo portresi",
    "Портрет, селфи": "Portre, selfie",
    "Применяем стиль": "Stil uygulanıyor",
    "Проверяем видео": "Video kontrol ediliyor",
    "Проверяем картинку": "Görsel kontrol ediliyor",
    "Проверяем описание": "Açıklama kontrol ediliyor",
    "Проверяем фото": "Fotoğraf kontrol ediliyor",
    "Раскрашено": "Renklendirildi",
    "Раскрашиваем": "Renklendiriliyor",
    "Рисуем варианты": "Varyantlar çiziliyor",
    "Рисуем по описанию": "Açıklamaya göre çiziliyor",
    "Ролик собран": "Video birleştirildi",
    "Ролик только по вашему описанию": "Yalnızca açıklamanıza göre bir video",
    "Ролик, который изменим": "Değiştireceğimiz video",
    "Свет поставлен": "Işık ayarlandı",
    "Селфи, портрет или любой снимок": "Selfie, portre veya herhangi bir fotoğraf",
    "Скачать № {0}": "{0} numaralıyı indir",
    "Смеётся": "Gülüyor",
    "Смотрит в камеру": "Kameraya bakıyor",
    "Снимаем движение": "Hareket çekiliyor",
    "Снимаем по описанию": "Açıklamaya göre çekiliyor",
    "Снимем из главного фото. Нажмите на фото, чтобы выбрать кадр": "Ana fotoğraftan çekeriz. Kadrajı seçmek için bir fotoğrafa dokunun",
    "Снимок оживёт движением камеры": "Fotoğraf kamera hareketiyle canlanacak",
    "Снято": "Çekildi",
    "Собираем ролик": "Video birleştiriliyor",
    "Создаём {0} фото": "{0} fotoğraf oluşturuluyor",
    "Создать {0} фото": "{0} fotoğraf oluştur",
    "Ставим вас в кадр": "Sizi kareye yerleştiriyoruz",
    "Ставим людей в кадр": "Kişileri kareye yerleştiriyoruz",
    "Ставим свет": "Işık ayarlanıyor",
    "Старый снимок или скан": "Eski fotoğraf veya tarama",
    "стилей": "stil",
    "Стили": "Stiller",
    "Стиль перенесён": "Stil aktarıldı",
    "Стиль применён": "Stil uygulandı",
    "Стиль шаблона": "Şablon stili",
    "Стиль STEOS": "STEOS stili",
    "стиля": "stil",
    "Строим объём": "Hacim oluşturuluyor",
    "Танцует": "Dans ediyor",
    "Товар крупно, на любом фоне": "Ürün yakın plan, herhangi bir arka plan",
    "Только для этого видео": "Yalnızca bu video için",
    "Только для этого фото": "Yalnızca bu fotoğraf için",
    "Тут откроется тема чата, куда бот прислал ролик": "Burada botun videoyu gönderdiği sohbet konusu açılacak",
    "Тут откроется тема чата, куда бот прислал фото": "Burada botun fotoğrafı gönderdiği sohbet konusu açılacak",
    "У моря": "Deniz kenarında",
    "Уберём царапины, шум и выцветание": "Çizikleri, gürültüyü ve solmayı gideririz",
    "Удалить из этого видео": "Bu videodan çıkar",
    "Удалить из этого фото": "Bu fotoğraftan çıkar",
    "Улыбается": "Gülümsüyor",
    "Файлы готовы": "Dosyalar hazır",
    "Фото готово": "Fotoğraf hazır",
    "Фото меняется только по вашему описанию": "Fotoğraf yalnızca açıklamanıza göre değişir",
    "Фото не прошло проверку": "Fotoğraf kontrolden geçmedi",
    "фото не создано": "fotoğraf oluşturulmadı",
    "Фото оживает как есть, без стиля": "Fotoğraf olduğu gibi, stilsiz canlanır",
    "Фото оживим, видео изменим": "Fotoğrafı canlandırır, videoyu değiştiririz",
    "Фото ожило": "Fotoğraf canlandı",
    "Фото проверено": "Fotoğraf kontrol edildi",
    "Фото, которое оживёт": "Canlanacak fotoğraf",
    "Фото, ролик, текст": "Fotoğraf, video, metin",
    "Цена": "Fiyat",
    "Чёрно-белый снимок или скан": "Siyah-beyaz fotoğraf veya tarama",
    "Что поменять": "Neyi değiştirmeli",
    "Что снимать": "Ne çekilsin",
    "Шаблон «{0}»": "«{0}» şablonu"
  },
  "kk": {
    "{0} · {1} C": "{0} · {1} C",
    "{0} «{1}»": "{0} «{1}»",
    "{0} с": "{0} с",
    "{0} сек": "{0} сек",
    "{0} секунд": "{0} секунд",
    "{0}: из чего": "{0}: неден",
    "Без обрезки, как снято": "Қиюсыз, түсірілгендей",
    "Без политики и запрещённых тем": "Саясатсыз және тыйым салынған тақырыптарсыз",
    "Бот уже прислал его в чат, в отдельную тему.": "Бот оны чатқа, жеке тақырыпқа жіберіп қойды.",
    "Бот уже прислал их в чат, в отдельную тему.": "Бот оларды чатқа жеке тақырыпқа жіберіп қойды.",
    "В кафе": "Кафеде",
    "В работу идёт до 10 секунд ролика. Из длинного выберите фрагмент под рамкой": "Роликтің 10 секундқа дейінгі бөлігі қолданылады. Ұзын роликтен жақтау астынан үзінді таңдаңыз",
    "Варианты готовы": "Нұсқалар дайын",
    "Ваш товар": "Сіздің тауарыңыз",
    "Ваше видео": "Сіздің бейнеңіз",
    "Ваше описание": "Сіздің сипаттамаңыз",
    "Вернём естественные цвета": "Табиғи түстерді қайтарамыз",
    "Видео будет со звуком: модель сама сгенерирует фон, шумы и музыку по сюжету. Речь можно добавить после создания: «Добавить речь»": "Бейне дыбыспен болады: модель фонды, шуды және музыканы сюжет бойынша өзі жасайды. Сөйлеуді жасағаннан кейін қосуға болады: «Сөйлеу қосу»",
    "Видео ещё загружается": "Бейне әлі жүктелуде",
    "Видео меняется по вашему описанию": "Бейне сіздің сипаттамаңыз бойынша өзгереді",
    "Видео не прошло проверку": "Бейне тексеруден өтпеді",
    "видео не создано": "бейне жасалмады",
    "Видео проверено": "Бейне тексерілді",
    "Восстанавливаем детали": "Бөлшектер қалпына келтірілуде",
    "Восстановление": "Қалпына келтіру",
    "Все движения": "Барлық қозғалыстар",
    "Вы в кадре": "Сіз кадрдасыз",
    "Выберите кадр": "Кадрды таңдаңыз",
    "Город ночью": "Түнгі қала",
    "Готовим файлы": "Файлдар дайындалуда",
    "Двигаем камеру": "Камера жылжытылуда",
    "Движение снято": "Қозғалыс түсірілді",
    "движений": "қозғалыс",
    "движения": "қозғалыс",
    "Держит за руку": "Қолымнан ұстап тұр",
    "Детали восстановлены": "Бөлшектер қалпына келтірілді",
    "Для аватарки и ленты": "Аватар мен лента үшін",
    "Для ленты": "Лента үшін",
    "Для обложки и экрана": "Мұқаба мен экран үшін",
    "Для Reels, Shorts и сторис": "Reels, Shorts және сторис үшін",
    "Для YouTube и экрана": "YouTube және экран үшін",
    "до 10 сек": "10 сек дейін",
    "Добавьте описание, от {0} знаков": "Сипаттама қосыңыз, кемінде {0} таңба",
    "Добавьте свои фото в «Кто в кадре»": "«Кадрда кім бар» бөліміне өз фотоларыңызды қосыңыз",
    "Добавьте фото людям в кадре": "Кадрдағы адамдарға фото қосыңыз",
    "за фото": "бір фото үшін",
    "Загрузите видео заново": "Бейнені қайта жүктеңіз",
    "Загрузите старое фото": "Ескі фотоны жүктеңіз",
    "Загрузите фото заново": "Фотоны қайта жүктеңіз",
    "Загрузите фото товара": "Тауар фотосын жүктеңіз",
    "Загрузите чёрно-белое фото": "Ақ-қара фотоны жүктеңіз",
    "Заменить видео": "Бейнені ауыстыру",
    "Заменить фото": "Фотоны ауыстыру",
    "Звук": "Дыбыс",
    "Идёт рядом": "Қасымда жүр",
    "из кадра": "кадрдан",
    "Из файла": "Файлдан",
    "Из фото": "Фотодан",
    "Изменено": "Өзгертілді",
    "Изменить описание": "Сипаттаманы өзгерту",
    "Искать среди {0} {1}": "{0} {1} ішінен іздеу",
    "Искать среди {0} {1} шаблона": "Үлгінің {0} {1} ішінен іздеу",
    "Кадры ожили": "Кадрлар жанданды",
    "Как снимок с телефона": "Телефонмен түсірілгендей",
    "Как у видео": "Бейнедегідей",
    "Камера прошла": "Камера өтті",
    "Картинка только по вашему описанию": "Тек сіздің сипаттамаңыз бойынша сурет",
    "Кафе": "Кафе",
    "Космос": "Ғарыш",
    "Лес": "Орман",
    "Лицо крупно, хороший свет": "Бет жақыннан, жарық жақсы",
    "Люди в кадре": "Адамдар кадрда",
    "Меняем по описанию": "Сипаттама бойынша өзгертілуде",
    "Можно уйти с экрана: бот пришлёт готовые фото в чат.": "Экраннан шыға беруге болады: бот дайын фотоларды чатқа жібереді.",
    "Можно уйти с экрана: бот пришлёт ролик в чат.": "Экраннан шыға беруге болады: бот роликті чатқа жібереді.",
    "На весь экран телефона": "Телефонның толық экраны",
    "на видео": "бейнеде",
    "На природе": "Табиғатта",
    "на фото": "фотода",
    "Нажмите, чтобы выбрать движение": "Қозғалысты таңдау үшін басыңыз",
    "Нажмите, чтобы выбрать стиль": "Стильді таңдау үшін басыңыз",
    "Нарисовано": "Салынды",
    "Не получилось сделать видео": "Бейне жасалмады",
    "Не получилось сделать фото": "Фото жасалмады",
    "Не прошло проверку": "Тексеруден өтпеді",
    "не участвует в этом видео": "бұл бейнеде жоқ",
    "не участвует в этом фото": "бұл фотода жоқ",
    "Необязательно": "Міндетті емес",
    "Обнимает меня": "Мені құшақтап тұр",
    "Объём построен": "Көлем жасалды",
    "Оживляем кадры": "Кадрлар жандандырылуда",
    "Оживляем фото": "Фотоны жандандырып жатырмыз",
    "Океан": "Мұхит",
    "Описание длиннее {0} знаков": "Сипаттама {0} таңбадан ұзын",
    "Описание не прошло проверку": "Сипаттама тексеруден өтпеді",
    "Описание проверено": "Сипаттама тексерілді",
    "От модели": "Модельден",
    "Пейзаж, портрет или любой снимок": "Пейзаж, портрет немесе кез келген сурет",
    "Переносим стиль на кадры": "Стиль кадрларға көшірілуде",
    "Переносим стиль с картинки": "Стиль суреттен көшірілуде",
    "Подходит для": "Қандай тауарға",
    "Портрет в студии": "Студиядағы портрет",
    "Портрет, селфи": "Портрет, селфи",
    "Применяем стиль": "Стиль қолданылуда",
    "Проверяем видео": "Бейнені тексеріп жатырмыз",
    "Проверяем картинку": "Сурет тексерілуде",
    "Проверяем описание": "Сипаттама тексерілуде",
    "Проверяем фото": "Фото тексерілуде",
    "Раскрашено": "Боялды",
    "Раскрашиваем": "Бояуда",
    "Рисуем варианты": "Нұсқалар салынуда",
    "Рисуем по описанию": "Сипаттама бойынша салынуда",
    "Ролик собран": "Ролик құрастырылды",
    "Ролик только по вашему описанию": "Тек сіздің сипаттамаңыз бойынша ролик",
    "Ролик, который изменим": "Өзгертілетін ролик",
    "Свет поставлен": "Жарық қойылды",
    "Селфи, портрет или любой снимок": "Селфи, портрет немесе кез келген сурет",
    "Скачать № {0}": "№ {0} жүктеп алу",
    "Смеётся": "Күледі",
    "Смотрит в камеру": "Камераға қарап тұр",
    "Снимаем движение": "Қозғалыс түсірілуде",
    "Снимаем по описанию": "Сипаттама бойынша түсірілуде",
    "Снимем из главного фото. Нажмите на фото, чтобы выбрать кадр": "Басты фотодан түсіреміз. Кадрды таңдау үшін фотоны басыңыз",
    "Снимок оживёт движением камеры": "Сурет камера қозғалысымен жанданады",
    "Снято": "Түсірілді",
    "Собираем ролик": "Ролик құрастырылуда",
    "Создаём {0} фото": "{0} фото жасалуда",
    "Создать {0} фото": "{0} фото жасау",
    "Ставим вас в кадр": "Сізді кадрға орналастыруда",
    "Ставим людей в кадр": "Адамдарды кадрға орналастыруда",
    "Ставим свет": "Жарық қойылуда",
    "Старый снимок или скан": "Ескі сурет немесе скан",
    "стилей": "стиль",
    "Стили": "Стильдер",
    "Стиль перенесён": "Стиль көшірілді",
    "Стиль применён": "Стиль қолданылды",
    "Стиль шаблона": "Үлгі стилі",
    "Стиль STEOS": "STEOS стилі",
    "стиля": "стиль",
    "Строим объём": "Көлем жасалуда",
    "Танцует": "Билеп тұр",
    "Товар крупно, на любом фоне": "Тауар жақыннан, кез келген фонда",
    "Только для этого видео": "Тек осы бейне үшін",
    "Только для этого фото": "Тек осы фото үшін",
    "Тут откроется тема чата, куда бот прислал ролик": "Мұнда бот роликті жіберген чат тақырыбы ашылады",
    "Тут откроется тема чата, куда бот прислал фото": "Мұнда бот фотоны жіберген чат тақырыбы ашылады",
    "У моря": "Теңіз жағасында",
    "Уберём царапины, шум и выцветание": "Сызаттарды, шуды және оңуды кетіреміз",
    "Удалить из этого видео": "Осы бейнеден алып тастау",
    "Удалить из этого фото": "Осы фотодан алып тастау",
    "Улыбается": "Күлімсіреп тұр",
    "Файлы готовы": "Файлдар дайын",
    "Фото готово": "Фото дайын",
    "Фото меняется только по вашему описанию": "Фото тек сіздің сипаттамаңыз бойынша өзгереді",
    "Фото не прошло проверку": "Фото тексеруден өтпеді",
    "фото не создано": "фото жасалмады",
    "Фото оживает как есть, без стиля": "Фото қалай болса солай, стильсіз жанданады",
    "Фото оживим, видео изменим": "Фотоны жандандырамыз, бейнені өзгертеміз",
    "Фото ожило": "Фото жанданды",
    "Фото проверено": "Фото тексерілді",
    "Фото, которое оживёт": "Жанданатын фото",
    "Фото, ролик, текст": "Фото, ролик, мәтін",
    "Цена": "Бағасы",
    "Чёрно-белый снимок или скан": "Ақ-қара сурет немесе скан",
    "Что поменять": "Нені ауыстыру керек",
    "Что снимать": "Не түсіру керек",
    "Шаблон «{0}»": "«{0}» үлгісі"
  },
  "uk": {
    "{0} · {1} C": "{0} · {1} C",
    "{0} «{1}»": "{0} «{1}»",
    "{0} с": "{0} с",
    "{0} сек": "{0} с",
    "{0} секунд": "{0} секунд",
    "{0}: из чего": "{0}: з чого",
    "Без обрезки, как снято": "Без обрізання, як знято",
    "Без политики и запрещённых тем": "Без політики та заборонених тем",
    "Бот уже прислал его в чат, в отдельную тему.": "Бот уже надіслав його в чат, в окрему тему.",
    "Бот уже прислал их в чат, в отдельную тему.": "Бот уже надіслав їх у чат, в окрему тему.",
    "В кафе": "У кафе",
    "В работу идёт до 10 секунд ролика. Из длинного выберите фрагмент под рамкой": "У роботу йде до 10 секунд ролика. З довгого виберіть фрагмент під рамкою",
    "Варианты готовы": "Варіанти готові",
    "Ваш товар": "Ваш товар",
    "Ваше видео": "Ваше відео",
    "Ваше описание": "Ваш опис",
    "Вернём естественные цвета": "Повернемо природні кольори",
    "Видео будет со звуком: модель сама сгенерирует фон, шумы и музыку по сюжету. Речь можно добавить после создания: «Добавить речь»": "Відео буде зі звуком: модель сама згенерує фон, шуми й музику за сюжетом. Мовлення можна додати після створення: «Додати мовлення»",
    "Видео ещё загружается": "Відео ще завантажується",
    "Видео меняется по вашему описанию": "Відео змінюється за вашим описом",
    "Видео не прошло проверку": "Відео не пройшло перевірку",
    "видео не создано": "відео не створено",
    "Видео проверено": "Відео перевірено",
    "Восстанавливаем детали": "Відновлюємо деталі",
    "Восстановление": "Відновлення",
    "Все движения": "Усі рухи",
    "Вы в кадре": "Ви в кадрі",
    "Выберите кадр": "Виберіть кадр",
    "Город ночью": "Місто вночі",
    "Готовим файлы": "Готуємо файли",
    "Двигаем камеру": "Рухаємо камеру",
    "Движение снято": "Рух знято",
    "движений": "рухів",
    "движения": "руху",
    "Держит за руку": "Тримає за руку",
    "Детали восстановлены": "Деталі відновлено",
    "Для аватарки и ленты": "Для аватарки та стрічки",
    "Для ленты": "Для стрічки",
    "Для обложки и экрана": "Для обкладинки та екрана",
    "Для Reels, Shorts и сторис": "Для Reels, Shorts та історій",
    "Для YouTube и экрана": "Для YouTube та екрана",
    "до 10 сек": "до 10 с",
    "Добавьте описание, от {0} знаков": "Додайте опис, від {0} знаків",
    "Добавьте свои фото в «Кто в кадре»": "Додайте свої фото в «Хто в кадрі»",
    "Добавьте фото людям в кадре": "Додайте фото людям у кадрі",
    "за фото": "за фото",
    "Загрузите видео заново": "Завантажте відео заново",
    "Загрузите старое фото": "Завантажте старе фото",
    "Загрузите фото заново": "Завантажте фото заново",
    "Загрузите фото товара": "Завантажте фото товару",
    "Загрузите чёрно-белое фото": "Завантажте чорно-біле фото",
    "Заменить видео": "Замінити відео",
    "Заменить фото": "Замінити фото",
    "Звук": "Звук",
    "Идёт рядом": "Іде поруч",
    "из кадра": "з кадру",
    "Из файла": "З файлу",
    "Из фото": "З фото",
    "Изменено": "Змінено",
    "Изменить описание": "Змінити опис",
    "Искать среди {0} {1}": "Шукати серед {0} {1}",
    "Искать среди {0} {1} шаблона": "Шукати серед {0} {1} шаблону",
    "Кадры ожили": "Кадри ожили",
    "Как снимок с телефона": "Як знімок з телефона",
    "Как у видео": "Як у відео",
    "Камера прошла": "Камера пройшла",
    "Картинка только по вашему описанию": "Зображення лише за вашим описом",
    "Кафе": "Кафе",
    "Космос": "Космос",
    "Лес": "Ліс",
    "Лицо крупно, хороший свет": "Обличчя крупно, добре світло",
    "Люди в кадре": "Люди в кадрі",
    "Меняем по описанию": "Змінюємо за описом",
    "Можно уйти с экрана: бот пришлёт готовые фото в чат.": "Можна піти з екрана: бот надішле готові фото в чат.",
    "Можно уйти с экрана: бот пришлёт ролик в чат.": "Можна піти з екрана: бот надішле ролик у чат.",
    "На весь экран телефона": "На весь екран телефона",
    "на видео": "на відео",
    "На природе": "На природі",
    "на фото": "на фото",
    "Нажмите, чтобы выбрать движение": "Торкніться, щоб вибрати рух",
    "Нажмите, чтобы выбрать стиль": "Торкніться, щоб вибрати стиль",
    "Нарисовано": "Намальовано",
    "Не получилось сделать видео": "Не вдалося створити відео",
    "Не получилось сделать фото": "Не вдалося створити фото",
    "Не прошло проверку": "Не пройшло перевірку",
    "не участвует в этом видео": "не бере участі в цьому відео",
    "не участвует в этом фото": "не бере участі в цьому фото",
    "Необязательно": "Необов’язково",
    "Обнимает меня": "Обіймає мене",
    "Объём построен": "Об’єм побудовано",
    "Оживляем кадры": "Оживляємо кадри",
    "Оживляем фото": "Оживляємо фото",
    "Океан": "Океан",
    "Описание длиннее {0} знаков": "Опис довший за {0} знаків",
    "Описание не прошло проверку": "Опис не пройшов перевірку",
    "Описание проверено": "Опис перевірено",
    "От модели": "Від моделі",
    "Пейзаж, портрет или любой снимок": "Пейзаж, портрет або будь-який знімок",
    "Переносим стиль на кадры": "Переносимо стиль на кадри",
    "Переносим стиль с картинки": "Переносимо стиль із картинки",
    "Подходит для": "Підходить для",
    "Портрет в студии": "Портрет у студії",
    "Портрет, селфи": "Портрет, селфі",
    "Применяем стиль": "Застосовуємо стиль",
    "Проверяем видео": "Перевіряємо відео",
    "Проверяем картинку": "Перевіряємо картинку",
    "Проверяем описание": "Перевіряємо опис",
    "Проверяем фото": "Перевіряємо фото",
    "Раскрашено": "Розфарбовано",
    "Раскрашиваем": "Розфарбовуємо",
    "Рисуем варианты": "Малюємо варіанти",
    "Рисуем по описанию": "Малюємо за описом",
    "Ролик собран": "Ролик зібрано",
    "Ролик только по вашему описанию": "Ролик лише за вашим описом",
    "Ролик, который изменим": "Ролик, який змінимо",
    "Свет поставлен": "Світло поставлено",
    "Селфи, портрет или любой снимок": "Селфі, портрет або будь-який знімок",
    "Скачать № {0}": "Завантажити № {0}",
    "Смеётся": "Сміється",
    "Смотрит в камеру": "Дивиться в камеру",
    "Снимаем движение": "Знімаємо рух",
    "Снимаем по описанию": "Знімаємо за описом",
    "Снимем из главного фото. Нажмите на фото, чтобы выбрать кадр": "Знімемо з головного фото. Торкніться фото, щоб вибрати кадр",
    "Снимок оживёт движением камеры": "Знімок оживе рухом камери",
    "Снято": "Знято",
    "Собираем ролик": "Збираємо ролик",
    "Создаём {0} фото": "Створюємо {0} фото",
    "Создать {0} фото": "Створити {0} фото",
    "Ставим вас в кадр": "Ставимо вас у кадр",
    "Ставим людей в кадр": "Ставимо людей у кадр",
    "Ставим свет": "Ставимо світло",
    "Старый снимок или скан": "Старий знімок або скан",
    "стилей": "стилів",
    "Стили": "Стилі",
    "Стиль перенесён": "Стиль перенесено",
    "Стиль применён": "Стиль застосовано",
    "Стиль шаблона": "Стиль шаблону",
    "Стиль STEOS": "Стиль STEOS",
    "стиля": "стилю",
    "Строим объём": "Будуємо об’єм",
    "Танцует": "Танцює",
    "Товар крупно, на любом фоне": "Товар крупно, на будь-якому тлі",
    "Только для этого видео": "Лише для цього відео",
    "Только для этого фото": "Лише для цього фото",
    "Тут откроется тема чата, куда бот прислал ролик": "Тут відкриється тема чату, куди бот надіслав ролик",
    "Тут откроется тема чата, куда бот прислал фото": "Тут відкриється тема чату, куди бот надіслав фото",
    "У моря": "Біля моря",
    "Уберём царапины, шум и выцветание": "Приберемо подряпини, шум і вицвітання",
    "Удалить из этого видео": "Прибрати з цього відео",
    "Удалить из этого фото": "Прибрати з цього фото",
    "Улыбается": "Усміхається",
    "Файлы готовы": "Файли готові",
    "Фото готово": "Фото готове",
    "Фото меняется только по вашему описанию": "Фото змінюється лише за вашим описом",
    "Фото не прошло проверку": "Фото не пройшло перевірку",
    "фото не создано": "фото не створено",
    "Фото оживает как есть, без стиля": "Фото оживає як є, без стилю",
    "Фото оживим, видео изменим": "Фото оживимо, відео змінимо",
    "Фото ожило": "Фото ожило",
    "Фото проверено": "Фото перевірено",
    "Фото, которое оживёт": "Фото, яке оживе",
    "Фото, ролик, текст": "Фото, ролик, текст",
    "Цена": "Ціна",
    "Чёрно-белый снимок или скан": "Чорно-білий знімок або скан",
    "Что поменять": "Що поміняти",
    "Что снимать": "Що знімати",
    "Шаблон «{0}»": "Шаблон «{0}»"
  },
  "zh": {
    "{0} · {1} C": "{0} · {1} C",
    "{0} «{1}»": "{0}「{1}」",
    "{0} с": "{0} 秒",
    "{0} сек": "{0} 秒",
    "{0} секунд": "{0} 秒",
    "{0}: из чего": "{0}：素材来源",
    "Без обрезки, как снято": "不裁剪，保持原样",
    "Без политики и запрещённых тем": "不涉及政治和违禁话题",
    "Бот уже прислал его в чат, в отдельную тему.": "机器人已把它发到聊天的单独话题中。",
    "Бот уже прислал их в чат, в отдельную тему.": "机器人已把它们发到聊天的单独话题中。",
    "В кафе": "在咖啡馆",
    "В работу идёт до 10 секунд ролика. Из длинного выберите фрагмент под рамкой": "最多使用视频的 10 秒。视频较长时，请在框内选择片段",
    "Варианты готовы": "版本已就绪",
    "Ваш товар": "你的商品",
    "Ваше видео": "你的视频",
    "Ваше описание": "你的描述",
    "Вернём естественные цвета": "我们会还原自然色彩",
    "Видео будет со звуком: модель сама сгенерирует фон, шумы и музыку по сюжету. Речь можно добавить после создания: «Добавить речь»": "视频将带声音：模型会根据情节自动生成背景音、音效和音乐。创建后可以添加语音：「添加语音」",
    "Видео ещё загружается": "视频仍在加载",
    "Видео меняется по вашему описанию": "视频会按你的描述修改",
    "Видео не прошло проверку": "视频未通过审核",
    "видео не создано": "视频未创建",
    "Видео проверено": "视频已检查",
    "Восстанавливаем детали": "正在修复细节",
    "Восстановление": "修复",
    "Все движения": "全部动作",
    "Вы в кадре": "你在画面中",
    "Выберите кадр": "选择画面",
    "Город ночью": "夜晚的城市",
    "Готовим файлы": "正在准备文件",
    "Двигаем камеру": "正在移动镜头",
    "Движение снято": "动作已拍摄",
    "движений": "个动作",
    "движения": "个动作",
    "Держит за руку": "牵着我的手",
    "Детали восстановлены": "细节已修复",
    "Для аватарки и ленты": "用于头像和动态",
    "Для ленты": "用于动态",
    "Для обложки и экрана": "用于封面和屏幕",
    "Для Reels, Shorts и сторис": "适用于 Reels、Shorts 和快拍",
    "Для YouTube и экрана": "适用于 YouTube 和屏幕",
    "до 10 сек": "最长 10 秒",
    "Добавьте описание, от {0} знаков": "添加描述，至少 {0} 个字符",
    "Добавьте свои фото в «Кто в кадре»": "在「画面中的人」中添加你的照片",
    "Добавьте фото людям в кадре": "为画面中的人添加照片",
    "за фото": "每张照片",
    "Загрузите видео заново": "重新上传视频",
    "Загрузите старое фото": "上传一张老照片",
    "Загрузите фото заново": "请重新上传照片",
    "Загрузите фото товара": "上传商品照片",
    "Загрузите чёрно-белое фото": "上传一张黑白照片",
    "Заменить видео": "替换视频",
    "Заменить фото": "替换照片",
    "Звук": "声音",
    "Идёт рядом": "走在我身边",
    "из кадра": "来自画面",
    "Из файла": "从文件",
    "Из фото": "取自照片",
    "Изменено": "已修改",
    "Изменить описание": "修改描述",
    "Искать среди {0} {1}": "在 {0} 个{1}中搜索",
    "Искать среди {0} {1} шаблона": "在 {0} 个模板{1}中搜索",
    "Кадры ожили": "画面已活起来",
    "Как снимок с телефона": "像手机拍的照片",
    "Как у видео": "与视频一致",
    "Камера прошла": "运镜完成",
    "Картинка только по вашему описанию": "仅根据你的描述生成图片",
    "Кафе": "咖啡馆",
    "Космос": "太空",
    "Лес": "森林",
    "Лицо крупно, хороший свет": "面部特写，光线充足",
    "Люди в кадре": "画面中有人",
    "Меняем по описанию": "按描述修改中",
    "Можно уйти с экрана: бот пришлёт готовые фото в чат.": "可以离开此页面：机器人会把完成的照片发到聊天中。",
    "Можно уйти с экрана: бот пришлёт ролик в чат.": "可以离开此页面：机器人会把视频发到聊天中。",
    "На весь экран телефона": "手机全屏",
    "на видео": "在视频中",
    "На природе": "大自然中",
    "на фото": "在照片中",
    "Нажмите, чтобы выбрать движение": "点击选择动作",
    "Нажмите, чтобы выбрать стиль": "点击选择风格",
    "Нарисовано": "已绘制",
    "Не получилось сделать видео": "视频生成失败",
    "Не получилось сделать фото": "照片生成失败",
    "Не прошло проверку": "未通过审核",
    "не участвует в этом видео": "不在此视频中",
    "не участвует в этом фото": "不在此照片中",
    "Необязательно": "可选",
    "Обнимает меня": "拥抱我",
    "Объём построен": "景深已构建",
    "Оживляем кадры": "正在让画面动起来",
    "Оживляем фото": "正在让照片动起来",
    "Океан": "海洋",
    "Описание длиннее {0} знаков": "描述超过 {0} 个字符",
    "Описание не прошло проверку": "描述未通过审核",
    "Описание проверено": "描述已审核",
    "От модели": "由模型决定",
    "Пейзаж, портрет или любой снимок": "风景、人像或任意照片",
    "Переносим стиль на кадры": "正在把风格应用到画面",
    "Переносим стиль с картинки": "正在从图片提取风格",
    "Подходит для": "适用于",
    "Портрет в студии": "影棚人像",
    "Портрет, селфи": "人像、自拍",
    "Применяем стиль": "正在应用风格",
    "Проверяем видео": "正在检查视频",
    "Проверяем картинку": "正在检查图片",
    "Проверяем описание": "正在检查描述",
    "Проверяем фото": "正在检查照片",
    "Раскрашено": "已上色",
    "Раскрашиваем": "正在上色",
    "Рисуем варианты": "正在绘制版本",
    "Рисуем по описанию": "正在按描述绘制",
    "Ролик собран": "视频已合成",
    "Ролик только по вашему описанию": "仅根据你的描述生成视频",
    "Ролик, который изменим": "要修改的视频",
    "Свет поставлен": "灯光已就位",
    "Селфи, портрет или любой снимок": "自拍、人像或任意照片",
    "Скачать № {0}": "下载第 {0} 个",
    "Смеётся": "在笑",
    "Смотрит в камеру": "看向镜头",
    "Снимаем движение": "正在拍摄动作",
    "Снимаем по описанию": "正在按描述拍摄",
    "Снимем из главного фото. Нажмите на фото, чтобы выбрать кадр": "将用主照片拍摄。点击照片选择画面",
    "Снимок оживёт движением камеры": "照片将随运镜动起来",
    "Снято": "已拍摄",
    "Собираем ролик": "正在合成视频",
    "Создаём {0} фото": "正在创建 {0} 张照片",
    "Создать {0} фото": "创建 {0} 张照片",
    "Ставим вас в кадр": "正在把你放入画面",
    "Ставим людей в кадр": "正在把人物放入画面",
    "Ставим свет": "正在布光",
    "Старый снимок или скан": "老照片或扫描件",
    "стилей": "种风格",
    "Стили": "风格",
    "Стиль перенесён": "已迁移风格",
    "Стиль применён": "已应用风格",
    "Стиль шаблона": "模板风格",
    "Стиль STEOS": "STEOS 风格",
    "стиля": "种风格",
    "Строим объём": "正在构建景深",
    "Танцует": "在跳舞",
    "Товар крупно, на любом фоне": "商品特写，任意背景",
    "Только для этого видео": "仅用于此视频",
    "Только для этого фото": "仅用于此照片",
    "Тут откроется тема чата, куда бот прислал ролик": "这里会打开机器人发送视频的聊天话题",
    "Тут откроется тема чата, куда бот прислал фото": "这里会打开机器人发送照片的聊天话题",
    "У моря": "海边",
    "Уберём царапины, шум и выцветание": "去除划痕、噪点和褪色",
    "Удалить из этого видео": "从此视频中移除",
    "Удалить из этого фото": "从此照片中移除",
    "Улыбается": "在微笑",
    "Файлы готовы": "文件已就绪",
    "Фото готово": "照片已完成",
    "Фото меняется только по вашему описанию": "照片仅按你的描述修改",
    "Фото не прошло проверку": "照片未通过审核",
    "фото не создано": "照片未生成",
    "Фото оживает как есть, без стиля": "照片原样动起来，不加风格",
    "Фото оживим, видео изменим": "让照片动起来，修改视频",
    "Фото ожило": "照片已活起来",
    "Фото проверено": "照片已审核",
    "Фото, которое оживёт": "要动起来的照片",
    "Фото, ролик, текст": "照片、视频、文字",
    "Цена": "价格",
    "Чёрно-белый снимок или скан": "黑白照片或扫描件",
    "Что поменять": "要改什么",
    "Что снимать": "拍什么",
    "Шаблон «{0}»": "模板「{0}」"
  }
}
